
!(function (e) {
    var t,
        i,
        o,
        n,
        a,
        s = this,
        r = ((e = jQuery = e), { sections: [] });
    class l {
        constructor(t) {
            var i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ".cc-".concat(t),
                o = this;
            (this.instances = []),
                e(document).on("cc:component:load", function (n, a, s) {
                    a === t &&
                        e(s)
                            .find("".concat(i, ":not(.cc-initialized)"))
                            .each(function () {
                                o.init(this);
                            });
                }),
                e(document).on("cc:component:unload", function (n, a, s) {
                    a === t &&
                        e(s)
                            .find(i)
                            .each(function () {
                                o.destroy(this);
                            });
                }),
                e(i).each(function () {
                    o.init(this);
                });
        }
        init(t) {
            e(t).addClass("cc-initialized");
        }
        destroy(t) {
            e(t).removeClass("cc-initialized");
        }
        registerInstance(e, t) {
            this.instances.push({ container: e, instance: t });
        }
        destroyInstance(e) {
            this.instances = this.instances.filter((t) => {
                if (t.container === e) return "function" == typeof t.instance.destroy && t.instance.destroy(), t.container !== e;
            });
        }
    }
    (theme.cartNoteMonitor = {
        load: function (t) {
            t.on("change.themeCartNoteMonitor paste.themeCartNoteMonitor keyup.themeCartNoteMonitor", function () {
                theme.cartNoteMonitor.postUpdate(e(this).val());
            });
        },
        unload: function (e) {
            e.off(".themeCartNoteMonitor");
        },
        updateThrottleTimeoutId: -1,
        updateThrottleInterval: 500,
        postUpdate: function (t) {
            clearTimeout(theme.cartNoteMonitor.updateThrottleTimeoutId),
                (theme.cartNoteMonitor.updateThrottleTimeoutId = setTimeout(function () {
                    e.post(theme.routes.cart_url + "/update.js", { note: t }, function (e) {}, "json");
                }, theme.cartNoteMonitor.updateThrottleInterval));
        },
    }),
        (theme.Shopify = {
            formatMoney: function (e, t) {
                function i(e, t) {
                    return void 0 === e ? t : e;
                }
                function o(e, t, o, n) {
                    if (((t = i(t, 2)), (o = i(o, ",")), (n = i(n, ".")), isNaN(e) || null == e)) return 0;
                    var a = (e = (e / 100).toFixed(t)).split(".");
                    return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + o) + (a[1] ? n + a[1] : "");
                }
                "string" == typeof e && (e = e.replace(".", ""));
                var n = "",
                    a = /\{\{\s*(\w+)\s*\}\}/,
                    s = t || this.money_format;
                switch (s.match(a)[1]) {
                    case "amount":
                        n = o(e, 2);
                        break;
                    case "amount_no_decimals":
                        n = o(e, 0);
                        break;
                    case "amount_with_comma_separator":
                        n = o(e, 2, ".", ",");
                        break;
                    case "amount_with_space_separator":
                        n = o(e, 2, " ", ",");
                        break;
                    case "amount_with_period_and_space_separator":
                        n = o(e, 2, " ", ".");
                        break;
                    case "amount_no_decimals_with_comma_separator":
                        n = o(e, 0, ".", ",");
                        break;
                    case "amount_no_decimals_with_space_separator":
                        n = o(e, 0, " ", "");
                        break;
                    case "amount_with_apostrophe_separator":
                        n = o(e, 2, "'", ".");
                        break;
                    case "amount_with_decimal_separator":
                        n = o(e, 2, ".", ".");
                }
                return s.replace(a, n);
            },
            formatImage: function (e, t) {
                return e ? e.replace(/^(.*)\.([^\.]*)$/g, "$1_" + t + ".$2") : "";
            },
            Image: {
                imageSize: function (e) {
                    var t = e.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
                    return null !== t ? t[1] : null;
                },
                getSizedImageUrl: function (e, t) {
                    if (null == t) return e;
                    if ("master" == t) return this.removeProtocol(e);
                    var i = e.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
                    if (null != i) {
                        var o = e.split(i[0]),
                            n = i[0];
                        return this.removeProtocol(o[0] + "_" + t + n);
                    }
                    return null;
                },
                removeProtocol: function (e) {
                    return e.replace(/http(s)?:/, "");
                },
            },
        }),
        (a = document.createEvent("Event")).initEvent("throttled-scroll", !0, !0),
        window.addEventListener(
            "scroll",
            ((t = function () {
                window.dispatchEvent(a);
            }),
            (i = 200),
            (o = -1),
            (n = !1),
            function () {
                clearTimeout(o),
                    (o = setTimeout(t, i)),
                    n ||
                        (t.call(),
                        (n = !0),
                        setTimeout(function () {
                            n = !1;
                        }, i));
            })
        ),
        (theme.Sections = new (function () {
            var t = this;
            (t._instances = []),
                (t._deferredSectionTargets = []),
                (t._sections = []),
                (t._deferredLoadViewportExcess = 300),
                (t._deferredWatcherRunning = !1),
                (t.init = function () {
                    e(document)
                        .on("shopify:section:load", function (e) {
                            var i = t._themeSectionTargetFromShopifySectionTarget(e.target);
                            i && t.sectionLoad(i);
                        })
                        .on("shopify:section:unload", function (e) {
                            var i = t._themeSectionTargetFromShopifySectionTarget(e.target);
                            i && t.sectionUnload(i);
                        }),
                        e(window).on("throttled-scroll.themeSectionDeferredLoader debouncedresize.themeSectionDeferredLoader", t._processDeferredSections),
                        (t._deferredWatcherRunning = !0);
                }),
                (t.register = function (i, o, n) {
                    t._sections.push({ type: i, section: o, afterSectionLoadCallback: n ? n.afterLoad : null, afterSectionUnloadCallback: n ? n.afterUnload : null }),
                        e('[data-section-type="' + i + '"]').each(function () {
                            Shopify.designMode || (n && !1 === n.deferredLoad) || !t._deferredWatcherRunning ? t.sectionLoad(this) : t.sectionDeferredLoad(this, n);
                        });
                }),
                (t.sectionDeferredLoad = function (e, i) {
                    t._deferredSectionTargets.push({ target: e, deferredLoadViewportExcess: i && i.deferredLoadViewportExcess ? i.deferredLoadViewportExcess : t._deferredLoadViewportExcess }), t._processDeferredSections(!0);
                }),
                (t._processDeferredSections = function (i) {
                    if (t._deferredSectionTargets.length)
                        for (var o = e(window).scrollTop(), n = o + e(window).height(), a = !0 === i ? t._deferredSectionTargets.length - 1 : 0; a < t._deferredSectionTargets.length; a++) {
                            var s = t._deferredSectionTargets[a].target,
                                r = t._deferredSectionTargets[a].deferredLoadViewportExcess,
                                l = e(s).offset().top - r,
                                c = l > o && l < n;
                            if (!c) {
                                var d = l + e(s).outerHeight() + 2 * r;
                                c = d > o && d < n;
                            }
                            (c || (l < o && d > n)) && (t.sectionLoad(s), t._deferredSectionTargets.splice(a, 1), a--);
                        }
                    !0 !== i && 0 === t._deferredSectionTargets.length && ((t._deferredWatcherRunning = !1), e(window).off(".themeSectionDeferredLoader"));
                }),
                (t.sectionLoad = function (i) {
                    var o = t._sectionForTarget(i),
                        n = !1;
                    if (!1 !== (n = o.section ? o.section : o)) {
                        var a = { target: i, section: n, $shopifySectionContainer: e(i).closest(".shopify-section"), thisContext: { functions: n.functions } };
                        if ((t._instances.push(a), e(i).data("components")))
                            e(i)
                                .data("components")
                                .split(",")
                                .forEach((t) => {
                                    e(document).trigger("cc:component:load", [t, i]);
                                });
                        t._callSectionWith(n, "onSectionLoad", i, a.thisContext),
                            t._callSectionWith(n, "afterSectionLoadCallback", i, a.thisContext),
                            n.onSectionSelect &&
                                a.$shopifySectionContainer.on("shopify:section:select", function (e) {
                                    t._callSectionWith(n, "onSectionSelect", e.target, a.thisContext);
                                }),
                            n.onSectionDeselect &&
                                a.$shopifySectionContainer.on("shopify:section:deselect", function (e) {
                                    t._callSectionWith(n, "onSectionDeselect", e.target, a.thisContext);
                                }),
                            n.onBlockSelect &&
                                e(i).on("shopify:block:select", function (e) {
                                    t._callSectionWith(n, "onBlockSelect", e.target, a.thisContext);
                                }),
                            n.onBlockDeselect &&
                                e(i).on("shopify:block:deselect", function (e) {
                                    t._callSectionWith(n, "onBlockDeselect", e.target, a.thisContext);
                                });
                    }
                }),
                (t.sectionUnload = function (i) {
                    for (var o = t._sectionForTarget(i), n = -1, a = 0; a < t._instances.length; a++) t._instances[a].target == i && (n = a);
                    if (n > -1) {
                        var s = t._instances[n];
                        if (
                            (e(i).off("shopify:block:select shopify:block:deselect"),
                            s.$shopifySectionContainer.off("shopify:section:select shopify:section:deselect"),
                            t._callSectionWith(s.section, "onSectionUnload", i, s.thisContext),
                            t._callSectionWith(o, "afterSectionUnloadCallback", i, s.thisContext),
                            t._instances.splice(n),
                            e(i).data("components"))
                        )
                            e(i)
                                .data("components")
                                .split(",")
                                .forEach((t) => {
                                    e(document).trigger("cc:component:unload", [t, i]);
                                });
                    } else
                        for (a = 0; a < t._deferredSectionTargets.length; a++)
                            if (t._deferredSectionTargets[a].target == i) {
                                t._deferredSectionTargets[a].splice(a, 1);
                                break;
                            }
                }),
                (t._callSectionWith = function (e, t, i, o) {
                    if ("function" == typeof e[t])
                        try {
                            o ? e[t].bind(o)(i) : e[t](i);
                        } catch (e) {
                            var n = i.dataset.sectionType;
                            console.log("Theme warning: '".concat(t, "' failed for section '").concat(n, "'")), console.debug(i, e.stack);
                        }
                }),
                (t._themeSectionTargetFromShopifySectionTarget = function (t) {
                    var i = e("[data-section-type]:first", t);
                    return i.length > 0 && i[0];
                }),
                (t._sectionForTarget = function (i) {
                    for (var o = e(i).attr("data-section-type"), n = 0; n < t._sections.length; n++) if (t._sections[n].type == o) return t._sections[n];
                    return !1;
                }),
                (t._sectionAlreadyRegistered = function (e) {
                    for (var i = 0; i < t._sections.length; i++) if (t._sections[i].type == e) return !0;
                    return !1;
                });
        })()),
        (theme.scriptsLoaded = {}),
        (theme.loadScriptOnce = function (e, t, i, o) {
            if (void 0 === theme.scriptsLoaded[e]) {
                theme.scriptsLoaded[e] = [];
                var n = document.createElement("script");
                (n.src = e),
                    (o || i) && (n.async = !1),
                    i && i(),
                    "function" == typeof t &&
                        (theme.scriptsLoaded[e].push(t),
                        n.readyState
                            ? (n.onreadystatechange = function () {
                                  if ("loaded" == n.readyState || "complete" == n.readyState) {
                                      n.onreadystatechange = null;
                                      for (var e = 0; e < theme.scriptsLoaded[this].length; e++) theme.scriptsLoaded[this][e]();
                                      theme.scriptsLoaded[this] = !0;
                                  }
                              }.bind(e))
                            : (n.onload = function () {
                                  for (var e = 0; e < theme.scriptsLoaded[this].length; e++) theme.scriptsLoaded[this][e]();
                                  theme.scriptsLoaded[this] = !0;
                              }.bind(e)));
                var a = document.getElementsByTagName("script")[0];
                return a.parentNode.insertBefore(n, a), !0;
            }
            if ("object" != typeof theme.scriptsLoaded[e] || "function" != typeof t) return "function" == typeof t && t(), !1;
            theme.scriptsLoaded[e].push(t);
        }),
        (theme.loadStyleOnce = function (e) {
            var t = e.replace(/^https?:/, "");
            if (!document.querySelector('link[href="' + encodeURI(t) + '"]')) {
                var i = document.createElement("link");
                (i.href = t), (i.rel = "stylesheet"), (i.type = "text/css");
                var o = document.getElementsByTagName("link")[0];
                o.parentNode.insertBefore(i, o);
            }
        }),
        (theme.Disclosure = (function () {
            var t = "[data-disclosure-list]",
                i = "[data-disclosure-toggle]",
                o = "[data-disclosure-input]",
                n = "[data-disclosure-option]",
                a = "disclosure-list--visible";
            function s(e) {
                (this.$container = e), (this.cache = {}), this._cacheSelectors(), this._connectOptions(), this._connectToggle(), this._onFocusOut();
            }
            return (
                (s.prototype = e.extend({}, s.prototype, {
                    _cacheSelectors: function () {
                        this.cache = { $disclosureList: this.$container.find(t), $disclosureToggle: this.$container.find(i), $disclosureInput: this.$container.find(o), $disclosureOptions: this.$container.find(n) };
                    },
                    _connectToggle: function () {
                        this.cache.$disclosureToggle.on(
                            "click",
                            function (t) {
                                var i = "true" === e(t.currentTarget).attr("aria-expanded");
                                e(t.currentTarget).attr("aria-expanded", !i), this.cache.$disclosureList.toggleClass(a);
                            }.bind(this)
                        );
                    },
                    _connectOptions: function () {
                        this.cache.$disclosureOptions.on(
                            "click",
                            function (t) {
                                t.preventDefault(), this._submitForm(e(t.currentTarget).data("value"));
                            }.bind(this)
                        );
                    },
                    _onFocusOut: function () {
                        this.cache.$disclosureToggle.on(
                            "focusout",
                            function (e) {
                                0 === this.$container.has(e.relatedTarget).length && this._hideList();
                            }.bind(this)
                        ),
                            this.cache.$disclosureList.on(
                                "focusout",
                                function (t) {
                                    var i = e(t.currentTarget).has(t.relatedTarget).length > 0;
                                    this.cache.$disclosureList.hasClass(a) && !i && this._hideList();
                                }.bind(this)
                            ),
                            this.$container.on(
                                "keyup",
                                function (e) {
                                    27 === e.which && (this._hideList(), this.cache.$disclosureToggle.focus());
                                }.bind(this)
                            ),
                            (this.bodyOnClick = function (e) {
                                var t = this.$container.has(e.target).length > 0;
                                this.cache.$disclosureList.hasClass(a) && !t && this._hideList();
                            }.bind(this)),
                            e("body").on("click", this.bodyOnClick);
                    },
                    _submitForm: function (e) {
                        this.cache.$disclosureInput.val(e), this.$container.parents("form").submit();
                    },
                    _hideList: function () {
                        this.cache.$disclosureList.removeClass(a), this.cache.$disclosureToggle.attr("aria-expanded", !1);
                    },
                    unload: function () {
                        e("body").off("click", this.bodyOnClick), this.cache.$disclosureOptions.off(), this.cache.$disclosureToggle.off(), this.cache.$disclosureList.off(), this.$container.off();
                    },
                })),
                s
            );
        })()),
        (theme.showQuickPopup = function (t, i) {
            var o = e('<div class="simple-popup"/>'),
                n = i.offset();
            o.html(t).css({ left: n.left, top: n.top }).hide(),
                e("body").append(o),
                o.css({ marginTop: -o.outerHeight() - 10, marginLeft: -(o.outerWidth() - i.outerWidth()) / 2 }),
                o
                    .fadeIn(200)
                    .delay(3500)
                    .fadeOut(400, function () {
                        e(this).remove();
                    });
        }),
        (e.scrollBarWidth = function () {
            var t = e("<div/>").css({ width: 100, height: 100, overflow: "scroll", position: "absolute", top: -9999 }).prependTo("body"),
                i = t[0].offsetWidth - t[0].clientWidth;
            return t.remove(), i;
        });
    class c {
        constructor(e) {
            (this.accordion = e),
                (this.itemClass = ".cc-accordion-item"),
                (this.titleClass = ".cc-accordion-item__title"),
                (this.panelClass = ".cc-accordion-item__panel"),
                (this.allowMultiOpen = "true" === this.accordion.dataset.allowMultiOpen),
                this.allowMultiOpen || (this.activeItem = this.accordion.querySelector("".concat(this.itemClass, "[open]"))),
                this.bindEvents();
        }
        static addPanelHeight(e) {
            e.style.height = "".concat(e.scrollHeight, "px");
        }
        static removePanelHeight(e) {
            e.getAttribute("style"), e.removeAttribute("style");
        }
        open(e, t) {
            if (
                ((t.style.height = "0"),
                (e.open = !0),
                c.addPanelHeight(t),
                setTimeout(() => {
                    e.classList.add("is-open");
                }, 10),
                !this.allowMultiOpen)
            ) {
                if (this.activeItem && this.activeItem !== e) {
                    var i = this.activeItem.querySelector(this.panelClass);
                    this.close(this.activeItem, i);
                }
                this.activeItem = e;
            }
        }
        close(e, t) {
            c.addPanelHeight(t),
                e.classList.remove("is-open"),
                e.classList.add("is-closing"),
                this.activeItem === e && (this.activeItem = null),
                setTimeout(() => {
                    t.style.height = "0";
                }, 10);
        }
        handleClick(e) {
            var t = e.target.closest(this.titleClass);
            if (t) {
                e.preventDefault();
                var i = t.parentNode,
                    o = t.nextElementSibling;
                i.open ? this.close(i, o) : this.open(i, o);
            }
        }
        handleTransition(e) {
            if (e.target.matches(this.panelClass)) {
                var t = e.target,
                    i = t.parentNode;
                i.classList.contains("is-closing") && (i.classList.remove("is-closing"), (i.open = !1)), c.removePanelHeight(t);
            }
        }
        bindEvents() {
            (this.clickHandler = this.handleClick.bind(this)),
                (this.transitionHandler = this.handleTransition.bind(this)),
                this.accordion.addEventListener("click", this.clickHandler),
                this.accordion.addEventListener("transitionend", this.transitionHandler);
        }
        destroy() {
            this.accordion.removeEventListener("click", this.clickHandler), this.accordion.removeEventListener("transitionend", this.transitionHandler);
        }
    }
    new (class extends l {
        constructor() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "accordion";
            super(e, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ".cc-".concat(e));
        }
        init(e) {
            super.init(e), this.registerInstance(e, new c(e));
        }
        destroy(e) {
            this.destroyInstance(e), super.destroy(e);
        }
    })(),
        (() => {
            (theme.initAnimateOnScroll = function () {
                if (document.body.classList.contains("cc-animate-enabled") && window.innerWidth >= 768) {
                    var e = void 0 !== document.body.dataset.ccAnimateTimeout ? document.body.dataset.ccAnimateTimeout : 200;
                    if ("IntersectionObserver" in window) {
                        var t = new IntersectionObserver((t, i) => {
                            t.forEach((t) => {
                                t.isIntersecting &&
                                    !t.target.classList.contains("cc-animate-complete") &&
                                    (setTimeout(() => {
                                        t.target.classList.add("-in", "cc-animate-complete");
                                    }, e),
                                    setTimeout(() => {
                                        t.target.classList.remove("data-cc-animate"), (t.target.style.transitionDuration = null), (t.target.style.transitionDelay = null);
                                    }, 5e3),
                                    i.unobserve(t.target));
                            });
                        });
                        document.querySelectorAll("[data-cc-animate]:not(.cc-animate-init)").forEach((e) => {
                            e.dataset.ccAnimateDelay && (e.style.transitionDelay = e.dataset.ccAnimateDelay),
                                e.dataset.ccAnimateDuration && (e.style.transitionDuration = e.dataset.ccAnimateDuration),
                                e.dataset.ccAnimate && e.classList.add(e.dataset.ccAnimate),
                                e.classList.add("cc-animate-init"),
                                t.observe(e);
                        });
                    } else for (var i = document.querySelectorAll("[data-cc-animate]:not(.cc-animate-init)"), o = 0; o < i.length; o++) i[o].classList.add("-in", "cc-animate-complete");
                }
            }),
                theme.initAnimateOnScroll(),
                document.addEventListener("shopify:section:load", () => {
                    setTimeout(theme.initAnimateOnScroll, 100);
                });
            try {
                window.matchMedia("(min-width: 768px)").addEventListener("change", (e) => {
                    e.matches && setTimeout(theme.initAnimateOnScroll, 100);
                });
            } catch (e) {}
        })();
    class d {
        constructor(e) {
            (this.el = e),
                (this.button = e.querySelector(".cc-select__btn")),
                (this.listbox = e.querySelector(".cc-select__listbox")),
                (this.options = e.querySelectorAll(".cc-select__option")),
                (this.selectedOption = e.querySelector('[aria-selected="true"]')),
                (this.nativeSelect = document.getElementById("".concat(e.id, "-native"))),
                (this.swatches = "swatch" in this.options[this.options.length - 1].dataset),
                (this.focusedClass = "is-focused"),
                (this.searchString = ""),
                (this.listboxOpen = !1),
                this.selectedOption || (this.selectedOption = this.listbox.firstElementChild),
                this.bindEvents(),
                this.setButtonWidth();
        }
        bindEvents() {
            this.el.addEventListener("keydown", this.handleKeydown.bind(this)), this.el.addEventListener("selectOption", this.handleSelectOption.bind(this)), this.button.addEventListener("mousedown", this.handleMousedown.bind(this));
        }
        addListboxOpenEvents() {
            (this.mouseoverHandler = this.handleMouseover.bind(this)),
                (this.mouseleaveHandler = this.handleMouseleave.bind(this)),
                (this.clickHandler = this.handleClick.bind(this)),
                (this.blurHandler = this.handleBlur.bind(this)),
                this.listbox.addEventListener("mouseover", this.mouseoverHandler),
                this.listbox.addEventListener("mouseleave", this.mouseleaveHandler),
                this.listbox.addEventListener("click", this.clickHandler),
                this.listbox.addEventListener("blur", this.blurHandler);
        }
        removeListboxOpenEvents() {
            this.listbox.removeEventListener("mouseover", this.mouseoverHandler),
                this.listbox.removeEventListener("mouseleave", this.mouseleaveHandler),
                this.listbox.removeEventListener("click", this.clickHandler),
                this.listbox.removeEventListener("blur", this.blurHandler);
        }
        handleKeydown(e) {
            this.listboxOpen ? this.handleKeyboardNav(e) : ("ArrowUp" !== e.key && "ArrowDown" !== e.key && " " !== e.key) || (e.preventDefault(), this.showListbox());
        }
        handleMousedown(e) {
            this.listboxOpen || 0 !== e.button || this.showListbox();
        }
        handleMouseover(e) {
            e.target.matches("li") && this.focusOption(e.target);
        }
        handleMouseleave() {
            this.focusOption(this.selectedOption);
        }
        handleClick(e) {
            e.target.matches(".js-option") && this.selectOption(e.target);
        }
        handleBlur() {
            this.listboxOpen && this.hideListbox();
        }
        handleKeyboardNav(e) {
            var t;
            switch (("Tab" === e.key && e.preventDefault(), e.key)) {
                case "ArrowUp":
                case "ArrowDown":
                    e.preventDefault(), (t = "ArrowUp" === e.key ? this.focusedOption.previousElementSibling : this.focusedOption.nextElementSibling) && !t.classList.contains("is-disabled") && this.focusOption(t);
                    break;
                case "Enter":
                case " ":
                    e.preventDefault(), this.selectOption(this.focusedOption);
                    break;
                case "Escape":
                    e.preventDefault(), this.hideListbox();
                    break;
                default:
                    (t = this.findOption(e.key)) && this.focusOption(t);
            }
        }
        setButtonWidth() {
            var e = (e) => {
                    var t = getComputedStyle(e);
                    return parseFloat(t.paddingLeft) + parseFloat(t.paddingRight);
                },
                t = e(this.button),
                i = e(this.selectedOption),
                o = this.button.offsetWidth - this.button.clientWidth,
                n = Math.ceil(this.selectedOption.getBoundingClientRect().width);
            this.button.style.width = "".concat(n - i + t + o, "px");
        }
        showListbox() {
            (this.listbox.hidden = !1),
                (this.listboxOpen = !0),
                this.el.classList.add("is-open"),
                this.button.setAttribute("aria-expanded", "true"),
                this.listbox.setAttribute("aria-hidden", "false"),
                setTimeout(() => {
                    this.focusOption(this.selectedOption), this.listbox.focus(), this.addListboxOpenEvents();
                }, 10);
        }
        hideListbox() {
            this.listboxOpen &&
                ((this.listbox.hidden = !0),
                (this.listboxOpen = !1),
                this.el.classList.remove("is-open"),
                this.button.setAttribute("aria-expanded", "false"),
                this.listbox.setAttribute("aria-hidden", "true"),
                this.focusedOption && (this.focusedOption.classList.remove(this.focusedClass), (this.focusedOption = null)),
                this.button.focus(),
                this.removeListboxOpenEvents());
        }
        findOption(e) {
            return (
                (this.searchString += e),
                this.searchTimer && clearTimeout(this.searchTimer),
                (this.searchTimer = setTimeout(() => {
                    this.searchString = "";
                }, 500)),
                [...this.options].find((e) => e.innerText.toLowerCase().includes(this.searchString) && !e.classList.contains("is-disabled"))
            );
        }
        focusOption(e) {
            if ((this.focusedOption && this.focusedOption.classList.remove(this.focusedClass), (this.focusedOption = e), this.focusedOption.classList.add(this.focusedClass), this.listbox.scrollHeight > this.listbox.clientHeight)) {
                var t = this.listbox.clientHeight + this.listbox.scrollTop,
                    i = e.offsetTop + e.offsetHeight;
                i > t ? (this.listbox.scrollTop = i - this.listbox.clientHeight) : e.offsetTop < this.listbox.scrollTop && (this.listbox.scrollTop = e.offsetTop);
            }
        }
        handleSelectOption(e) {
            var t = [...this.options].find((t) => t.dataset.value === e.detail.value);
            t && this.selectOption(t);
        }
        selectOption(e) {
            if (e !== this.selectedOption)
                if (
                    (e.setAttribute("aria-selected", "true"),
                    this.selectedOption.setAttribute("aria-selected", "false"),
                    this.swatches && (e.dataset.swatch ? (this.button.dataset.swatch = e.dataset.swatch) : this.button.removeAttribute("data-swatch")),
                    (this.button.firstChild.textContent = e.firstElementChild.textContent),
                    this.listbox.setAttribute("aria-activedescendant", e.id),
                    (this.selectedOption = document.getElementById(e.id)),
                    this.nativeSelect)
                )
                    (this.nativeSelect.value = e.dataset.value), this.nativeSelect.dispatchEvent(new Event("change", { bubbles: !0 }));
                else {
                    var t = { selectedValue: e.dataset.value };
                    this.el.dispatchEvent(new CustomEvent("change", { bubbles: !0, detail: t }));
                }
            this.hideListbox();
        }
    }
    new (class extends l {
        constructor() {
            super(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "custom-select", arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ".cc-select");
        }
        init(e) {
            super.init(e), this.registerInstance(e, new d(e));
        }
        destroy(e) {
            this.destroyInstance(e), super.destroy(e);
        }
    })();
    class h {
        constructor(e, t) {
            (this.$container = e), (this.namespace = t), (this.cssClasses = { visible: "cc-popup--visible", bodyNoScroll: "cc-popup-no-scroll", bodyNoScrollPadRight: "cc-popup-no-scroll-pad-right" });
        }
        open(t) {
            if (this.$container.data("freeze-scroll")) {
                e("body").addClass(this.cssClasses.bodyNoScroll);
                var i = document.createElement("div");
                (i.className = "popup-scrollbar-measure"), document.body.appendChild(i);
                var o = i.getBoundingClientRect().width - i.clientWidth;
                document.body.removeChild(i),
                    o > 0 &&
                        e("body")
                            .css("padding-right", o + "px")
                            .addClass(this.cssClasses.bodyNoScrollPadRight);
            }
            this.$container.addClass(this.cssClasses.visible),
                (this.previouslyActiveElement = document.activeElement),
                setTimeout(() => {
                    this.$container.find(".cc-popup-close")[0].focus();
                }, 500),
                e(window).on("keydown" + this.namespace, (e) => {
                    27 === e.keyCode && this.close();
                }),
                t && t();
        }
        close(t) {
            if ((this.$container.removeClass(this.cssClasses.visible), this.previouslyActiveElement && e(this.previouslyActiveElement).focus(), e(window).off("keydown" + this.namespace), this.$container.data("freeze-scroll"))) {
                var i = 500,
                    o = this.$container.find(".cc-popup-modal");
                o.length && (i = parseFloat(getComputedStyle(o[0]).transitionDuration)) && i > 0 && (i *= 1e3),
                    setTimeout(() => {
                        e("body").removeClass(this.cssClasses.bodyNoScroll).removeClass(this.cssClasses.bodyNoScrollPadRight).css("padding-right", "0");
                    }, i);
            }
            t && t();
        }
    }
    (theme.VideoManager = new (function () {
        var t = this;
        (t._permitPlayback = function (t) {
            return !(e(t).hasClass("video-container--background") && e(window).outerWidth() < 768);
        }),
            (t.youtubeVars = { incrementor: 0, apiReady: !1, videoData: {}, toProcessSelector: '.video-container[data-video-type="youtube"]:not(.video--init)' }),
            (t.youtubeApiReady = function () {
                (t.youtubeVars.apiReady = !0), t._loadYoutubeVideos();
            }),
            (t._loadYoutubeVideos = function (i) {
                e(t.youtubeVars.toProcessSelector, i).length &&
                    (t.youtubeVars.apiReady
                        ? e(t.youtubeVars.toProcessSelector, i).each(function () {
                              if (t._permitPlayback(e(this))) {
                                  e(this).addClass("video--init"), t.youtubeVars.incrementor++;
                                  var i = "theme-yt-video-" + t.youtubeVars.incrementor;
                                  e(this).data("video-container-id", i);
                                  var o = e('<div class="video-container__video-element">').attr("id", i).appendTo(e(".video-container__video", this)),
                                      n = e(this).data("video-autoplay"),
                                      a = e(this).data("video-loop"),
                                      s = new YT.Player(i, {
                                          height: "360",
                                          width: "640",
                                          videoId: e(this).data("video-id"),
                                          playerVars: { iv_load_policy: 3, modestbranding: 1, autoplay: 0, loop: a ? 1 : 0, playlist: e(this).data("video-id"), rel: 0, showinfo: 0 },
                                          events: { onReady: t._onYoutubePlayerReady.bind({ autoplay: n, loop: a, $container: e(this) }), onStateChange: t._onYoutubePlayerStateChange.bind({ autoplay: n, loop: a, $container: e(this) }) },
                                      });
                                  t.youtubeVars.videoData[i] = { id: i, container: this, videoElement: o, player: s };
                              }
                          })
                        : theme.loadScriptOnce("https://www.youtube.com/iframe_api"));
            }),
            (t._onYoutubePlayerReady = function (e) {
                e.target.setPlaybackQuality("hd1080"), this.autoplay && (e.target.mute(), e.target.playVideo()), t._initBackgroundVideo(this.$container);
            }),
            (t._onYoutubePlayerStateChange = function (e) {
                if (e.data == YT.PlayerState.PLAYING && (this.$container.addClass("video--play-started"), this.autoplay && e.target.mute(), this.loop)) {
                    var t = e.target.getDuration() - 1;
                    if (t > 2) {
                        !(function i() {
                            e.target.getCurrentTime() > t && e.target.seekTo(0), setTimeout(i, 250);
                        })();
                    }
                }
            }),
            (t._unloadYoutubeVideos = function (i) {
                for (var o in t.youtubeVars.videoData) {
                    var n = t.youtubeVars.videoData[o];
                    if (e(i).find(n.container).length) return n.player.destroy(), void delete t.youtubeVars.videoData[o];
                }
            }),
            (t.vimeoVars = { incrementor: 0, apiReady: !1, videoData: {}, toProcessSelector: '.video-container[data-video-type="vimeo"]:not(.video--init)' }),
            (t.vimeoApiReady = function () {
                (t.vimeoVars.apiReady = !0), t._loadVimeoVideos();
            }),
            (t._loadVimeoVideos = function (i) {
                e(t.vimeoVars.toProcessSelector, i).length &&
                    (t.vimeoVars.apiReady
                        ? e(t.vimeoVars.toProcessSelector, i).each(function () {
                              if (t._permitPlayback(e(this))) {
                                  e(this).addClass("video--init"), t.vimeoVars.incrementor++;
                                  var i = e(this),
                                      o = "theme-vi-video-" + t.vimeoVars.incrementor;
                                  e(this).data("video-container-id", o);
                                  var n = e('<div class="video-container__video-element">').attr("id", o).appendTo(e(".video-container__video", this)),
                                      a = !!e(this).data("video-autoplay"),
                                      s = new Vimeo.Player(o, { url: e(this).data("video-url"), width: 640, loop: e(this).data("video-autoplay"), autoplay: a, muted: i.hasClass("video-container--background") || a });
                                  s.on(
                                      "playing",
                                      function () {
                                          e(this).addClass("video--play-started");
                                      }.bind(this)
                                  ),
                                      s.ready().then(function () {
                                          if ((a && (s.setVolume(0), s.play()), s.element && s.element.width && s.element.height)) {
                                              var e = parseInt(s.element.height) / parseInt(s.element.width);
                                              i.find(".video-container__video").css("padding-bottom", 100 * e + "%");
                                          }
                                          t._initBackgroundVideo(i);
                                      }),
                                      (t.vimeoVars.videoData[o] = { id: o, container: this, videoElement: n, player: s, autoPlay: a });
                              }
                          })
                        : window.define
                        ? theme.loadScriptOnce(
                              "https://player.vimeo.com/api/player.js",
                              function () {
                                  (t.vimeoVars.apiReady = !0), t._loadVimeoVideos(), (window.define = window.tempDefine);
                              },
                              function () {
                                  (window.tempDefine = window.define), (window.define = null);
                              }
                          )
                        : theme.loadScriptOnce("https://player.vimeo.com/api/player.js", function () {
                              (t.vimeoVars.apiReady = !0), t._loadVimeoVideos();
                          }));
            }),
            (t._unloadVimeoVideos = function (i) {
                for (var o in t.vimeoVars.videoData) {
                    var n = t.vimeoVars.videoData[o];
                    if (e(i).find(n.container).length) return n.player.unload(), void delete t.vimeoVars.videoData[o];
                }
            }),
            (t._loadThirdPartyApis = function (i) {
                t._permitPlayback(e(".video-container", i)) && (t._loadYoutubeVideos(i), t._loadVimeoVideos(i));
            }),
            (t.mp4Vars = { incrementor: 0, videoData: {}, toProcessSelector: '.video-container[data-video-type="mp4"]:not(.video--init)' }),
            (t._loadMp4Videos = function (i) {
                e(t.mp4Vars.toProcessSelector, i).length &&
                    e(t.mp4Vars.toProcessSelector, i)
                        .addClass("video--init")
                        .each(function () {
                            t.mp4Vars.incrementor++;
                            e(this);
                            var i = "theme-mp-video-" + t.mp4Vars.incrementor;
                            e(this).data("video-container-id", i);
                            var o = e('<div class="video-container__video-element">').attr("id", i).appendTo(e(".video-container__video", this)),
                                n = e("<video playsinline>");
                            e(this).data("video-loop") && n.attr("loop", "loop"),
                                e(this).hasClass("video-container--background") || n.attr("controls", "controls"),
                                e(this).data("video-autoplay") &&
                                    (n.attr({ autoplay: "autoplay", muted: "muted" }),
                                    (n[0].muted = !0),
                                    n.one("loadeddata", function () {
                                        this.play();
                                    })),
                                n.on(
                                    "playing",
                                    function () {
                                        e(this).addClass("video--play-started");
                                    }.bind(this)
                                ),
                                n.attr("src", e(this).data("video-url")).appendTo(o),
                                (t.mp4Vars.videoData[i] = { element: n[0] });
                        });
            }),
            (t._unloadMp4Videos = function (e) {}),
            (t._initBackgroundVideo = function (t) {
                if (t.hasClass("video-container--background") && t.find(".video-container__video iframe").length) {
                    function i() {
                        var t = e(".video-container__media", this),
                            i = t.length ? t : this,
                            o = i.width(),
                            n = i.height(),
                            a = o / n,
                            s = e(".video-container__video iframe", this),
                            r = s.attr("width") / s.attr("height"),
                            l = e(".video-container__video", this),
                            c = 75;
                        if (a > r) {
                            var d = o / r + 150;
                            l.css({ marginTop: (n - d) / 2 - c, marginInlineStart: "", height: d + 150, width: "" });
                        } else {
                            var h = o * r + 150 * r;
                            l.css({ marginTop: -75, marginInlineStart: (o - h) / 2, height: n + 150, width: h });
                        }
                    }
                    i.bind(t)(), e(window).on("debouncedresize." + t.data("video-container-id"), i.bind(t));
                }
            }),
            (this.onSectionLoad = function (i) {
                e(".video-container[data-video-url]:not([data-video-type])").each(function () {
                    var t = e(this).data("video-url");
                    t.indexOf(".mp4") > -1 && e(this).attr("data-video-type", "mp4"),
                        t.indexOf("vimeo.com") > -1 && (e(this).attr("data-video-type", "vimeo"), e(this).attr("data-video-id", t.split("?")[0].split("/").pop())),
                        (t.indexOf("youtu.be") > -1 || t.indexOf("youtube.com") > -1) &&
                            (e(this).attr("data-video-type", "youtube"), t.indexOf("v=") > -1 ? e(this).attr("data-video-id", t.split("v=").pop().split("&")[0]) : e(this).attr("data-video-id", t.split("?")[0].split("/").pop()));
                }),
                    t._loadThirdPartyApis(i),
                    t._loadMp4Videos(i),
                    e(window).on("debouncedresize.video-manager-resize", function () {
                        t._loadThirdPartyApis(i);
                    }),
                    e(".video-container__play", i).on("click", function (o) {
                        o.preventDefault();
                        var n = e(this).closest(".video-container");
                        n.addClass("video-container--playing"), e(i).trigger("cc:video:play");
                        var a = n.data("video-container-id");
                        0 === a.indexOf("theme-yt-video")
                            ? t.youtubeVars.videoData[a].player.playVideo()
                            : 0 === a.indexOf("theme-vi-video")
                            ? t.vimeoVars.videoData[a].player.play()
                            : 0 === a.indexOf("theme-mp-video") && t.mp4Vars.videoData[a].element.play();
                    }),
                    e(".video-container__stop", i).on("click", function (o) {
                        o.preventDefault();
                        var n = e(this).closest(".video-container");
                        n.removeClass("video-container--playing"), e(i).trigger("cc:video:stop");
                        var a = n.data("video-container-id");
                        0 === a.indexOf("theme-yt-video") ? t.youtubeVars.videoData[a].player.stopVideo() : (t.vimeoVars.videoData[a].player.pause(), t.vimeoVars.videoData[a].player.setCurrentTime(0));
                    });
            }),
            (this.onSectionUnload = function (i) {
                e(".video-container__play, .video-container__stop", i).off("click"),
                    e(window).off("." + e(".video-container").data("video-container-id")),
                    e(window).off("debouncedresize.video-manager-resize"),
                    t._unloadYoutubeVideos(i),
                    t._unloadVimeoVideos(i),
                    t._unloadMp4Videos(i),
                    e(i).trigger("cc:video:stop");
            });
    })()),
        (window.onYouTubeIframeAPIReady = function () {
            theme.VideoManager.youtubeApiReady();
        }),
        r.sections.push({ name: "video", section: theme.VideoManager }),
        (theme.MapSection = new (function () {
            var t = this;
            (t.config = {
                zoom: 14,
                styles: {
                    default: [],
                    silver: [
                        { elementType: "geometry", stylers: [{ color: "#f5f5f5" }] },
                        { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
                        { elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
                        { elementType: "labels.text.stroke", stylers: [{ color: "#f5f5f5" }] },
                        { featureType: "administrative.land_parcel", elementType: "labels.text.fill", stylers: [{ color: "#bdbdbd" }] },
                        { featureType: "poi", elementType: "geometry", stylers: [{ color: "#eeeeee" }] },
                        { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
                        { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#e5e5e5" }] },
                        { featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
                        { featureType: "road", elementType: "geometry", stylers: [{ color: "#ffffff" }] },
                        { featureType: "road.arterial", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
                        { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#dadada" }] },
                        { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
                        { featureType: "road.local", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
                        { featureType: "transit.line", elementType: "geometry", stylers: [{ color: "#e5e5e5" }] },
                        { featureType: "transit.station", elementType: "geometry", stylers: [{ color: "#eeeeee" }] },
                        { featureType: "water", elementType: "geometry", stylers: [{ color: "#c9c9c9" }] },
                        { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
                    ],
                    retro: [
                        { elementType: "geometry", stylers: [{ color: "#ebe3cd" }] },
                        { elementType: "labels.text.fill", stylers: [{ color: "#523735" }] },
                        { elementType: "labels.text.stroke", stylers: [{ color: "#f5f1e6" }] },
                        { featureType: "administrative", elementType: "geometry.stroke", stylers: [{ color: "#c9b2a6" }] },
                        { featureType: "administrative.land_parcel", elementType: "geometry.stroke", stylers: [{ color: "#dcd2be" }] },
                        { featureType: "administrative.land_parcel", elementType: "labels.text.fill", stylers: [{ color: "#ae9e90" }] },
                        { featureType: "landscape.natural", elementType: "geometry", stylers: [{ color: "#dfd2ae" }] },
                        { featureType: "poi", elementType: "geometry", stylers: [{ color: "#dfd2ae" }] },
                        { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#93817c" }] },
                        { featureType: "poi.park", elementType: "geometry.fill", stylers: [{ color: "#a5b076" }] },
                        { featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#447530" }] },
                        { featureType: "road", elementType: "geometry", stylers: [{ color: "#f5f1e6" }] },
                        { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#fdfcf8" }] },
                        { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#f8c967" }] },
                        { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#e9bc62" }] },
                        { featureType: "road.highway.controlled_access", elementType: "geometry", stylers: [{ color: "#e98d58" }] },
                        { featureType: "road.highway.controlled_access", elementType: "geometry.stroke", stylers: [{ color: "#db8555" }] },
                        { featureType: "road.local", elementType: "labels.text.fill", stylers: [{ color: "#806b63" }] },
                        { featureType: "transit.line", elementType: "geometry", stylers: [{ color: "#dfd2ae" }] },
                        { featureType: "transit.line", elementType: "labels.text.fill", stylers: [{ color: "#8f7d77" }] },
                        { featureType: "transit.line", elementType: "labels.text.stroke", stylers: [{ color: "#ebe3cd" }] },
                        { featureType: "transit.station", elementType: "geometry", stylers: [{ color: "#dfd2ae" }] },
                        { featureType: "water", elementType: "geometry.fill", stylers: [{ color: "#b9d3c2" }] },
                        { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#92998d" }] },
                    ],
                    dark: [
                        { elementType: "geometry", stylers: [{ color: "#212121" }] },
                        { elementType: "labels.icon", stylers: [{ visibility: "off" }] },
                        { elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
                        { elementType: "labels.text.stroke", stylers: [{ color: "#212121" }] },
                        { featureType: "administrative", elementType: "geometry", stylers: [{ color: "#757575" }] },
                        { featureType: "administrative.country", elementType: "labels.text.fill", stylers: [{ color: "#9e9e9e" }] },
                        { featureType: "administrative.land_parcel", stylers: [{ visibility: "off" }] },
                        { featureType: "administrative.locality", elementType: "labels.text.fill", stylers: [{ color: "#bdbdbd" }] },
                        { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
                        { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#181818" }] },
                        { featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
                        { featureType: "poi.park", elementType: "labels.text.stroke", stylers: [{ color: "#1b1b1b" }] },
                        { featureType: "road", elementType: "geometry.fill", stylers: [{ color: "#2c2c2c" }] },
                        { featureType: "road", elementType: "labels.text.fill", stylers: [{ color: "#8a8a8a" }] },
                        { featureType: "road.arterial", elementType: "geometry", stylers: [{ color: "#373737" }] },
                        { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#3c3c3c" }] },
                        { featureType: "road.highway.controlled_access", elementType: "geometry", stylers: [{ color: "#4e4e4e" }] },
                        { featureType: "road.local", elementType: "labels.text.fill", stylers: [{ color: "#616161" }] },
                        { featureType: "transit", elementType: "labels.text.fill", stylers: [{ color: "#757575" }] },
                        { featureType: "water", elementType: "geometry", stylers: [{ color: "#000000" }] },
                        { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#3d3d3d" }] },
                    ],
                    night: [
                        { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
                        { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
                        { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
                        { featureType: "administrative.locality", elementType: "labels.text.fill", stylers: [{ color: "#d59563" }] },
                        { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#d59563" }] },
                        { featureType: "poi.park", elementType: "geometry", stylers: [{ color: "#263c3f" }] },
                        { featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#6b9a76" }] },
                        { featureType: "road", elementType: "geometry", stylers: [{ color: "#38414e" }] },
                        { featureType: "road", elementType: "geometry.stroke", stylers: [{ color: "#212a37" }] },
                        { featureType: "road", elementType: "labels.text.fill", stylers: [{ color: "#9ca5b3" }] },
                        { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#746855" }] },
                        { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#1f2835" }] },
                        { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ color: "#f3d19c" }] },
                        { featureType: "transit", elementType: "geometry", stylers: [{ color: "#2f3948" }] },
                        { featureType: "transit.station", elementType: "labels.text.fill", stylers: [{ color: "#d59563" }] },
                        { featureType: "water", elementType: "geometry", stylers: [{ color: "#17263c" }] },
                        { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#515c6d" }] },
                        { featureType: "water", elementType: "labels.text.stroke", stylers: [{ color: "#17263c" }] },
                    ],
                    aubergine: [
                        { elementType: "geometry", stylers: [{ color: "#1d2c4d" }] },
                        { elementType: "labels.text.fill", stylers: [{ color: "#8ec3b9" }] },
                        { elementType: "labels.text.stroke", stylers: [{ color: "#1a3646" }] },
                        { featureType: "administrative.country", elementType: "geometry.stroke", stylers: [{ color: "#4b6878" }] },
                        { featureType: "administrative.land_parcel", elementType: "labels.text.fill", stylers: [{ color: "#64779e" }] },
                        { featureType: "administrative.province", elementType: "geometry.stroke", stylers: [{ color: "#4b6878" }] },
                        { featureType: "landscape.man_made", elementType: "geometry.stroke", stylers: [{ color: "#334e87" }] },
                        { featureType: "landscape.natural", elementType: "geometry", stylers: [{ color: "#023e58" }] },
                        { featureType: "poi", elementType: "geometry", stylers: [{ color: "#283d6a" }] },
                        { featureType: "poi", elementType: "labels.text.fill", stylers: [{ color: "#6f9ba5" }] },
                        { featureType: "poi", elementType: "labels.text.stroke", stylers: [{ color: "#1d2c4d" }] },
                        { featureType: "poi.park", elementType: "geometry.fill", stylers: [{ color: "#023e58" }] },
                        { featureType: "poi.park", elementType: "labels.text.fill", stylers: [{ color: "#3C7680" }] },
                        { featureType: "road", elementType: "geometry", stylers: [{ color: "#304a7d" }] },
                        { featureType: "road", elementType: "labels.text.fill", stylers: [{ color: "#98a5be" }] },
                        { featureType: "road", elementType: "labels.text.stroke", stylers: [{ color: "#1d2c4d" }] },
                        { featureType: "road.highway", elementType: "geometry", stylers: [{ color: "#2c6675" }] },
                        { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ color: "#255763" }] },
                        { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ color: "#b0d5ce" }] },
                        { featureType: "road.highway", elementType: "labels.text.stroke", stylers: [{ color: "#023e58" }] },
                        { featureType: "transit", elementType: "labels.text.fill", stylers: [{ color: "#98a5be" }] },
                        { featureType: "transit", elementType: "labels.text.stroke", stylers: [{ color: "#1d2c4d" }] },
                        { featureType: "transit.line", elementType: "geometry.fill", stylers: [{ color: "#283d6a" }] },
                        { featureType: "transit.station", elementType: "geometry", stylers: [{ color: "#3a4762" }] },
                        { featureType: "water", elementType: "geometry", stylers: [{ color: "#0e1626" }] },
                        { featureType: "water", elementType: "labels.text.fill", stylers: [{ color: "#4e6d70" }] },
                    ],
                },
            }),
                (t.apiStatus = null),
                (this.geolocate = function (t) {
                    var i = e.Deferred(),
                        o = new google.maps.Geocoder(),
                        n = t.data("address-setting");
                    return (
                        o.geocode({ address: n }, function (e, t) {
                            t !== google.maps.GeocoderStatus.OK && i.reject(t), i.resolve(e);
                        }),
                        i
                    );
                }),
                (this.createMap = function (i) {
                    var o = e(".map-section__map-container", i);
                    return t
                        .geolocate(o)
                        .then(
                            function (n) {
                                var a = { zoom: t.config.zoom, styles: t.config.styles[e(i).data("map-style")], center: n[0].geometry.location, scrollwheel: !1, disableDoubleClickZoom: !0, disableDefaultUI: !0, zoomControl: !0 };
                                (t.map = new google.maps.Map(o[0], a)), (t.center = t.map.getCenter());
                                new google.maps.Marker({ map: t.map, position: t.center, clickable: !1 });
                                google.maps.event.addDomListener(window, "resize", function () {
                                    google.maps.event.trigger(t.map, "resize"), t.map.setCenter(t.center);
                                });
                            }.bind(this)
                        )
                        .fail(function () {
                            var e;
                            switch (status) {
                                case "ZERO_RESULTS":
                                    e = theme.strings.addressNoResults;
                                    break;
                                case "OVER_QUERY_LIMIT":
                                    e = theme.strings.addressQueryLimit;
                                    break;
                                default:
                                    e = theme.strings.addressError;
                            }
                            if (Shopify.designMode) {
                                var t = o.parents(".map-section");
                                t.addClass("page-width map-section--load-error"), t.find(".map-section__wrapper").html('<div class="errors text-center">' + e + "</div>");
                            }
                        });
                }),
                (this.onSectionLoad = function (i) {
                    var o = e(i);
                    window.gm_authFailure = function () {
                        Shopify.designMode && (o.addClass("page-width map-section--load-error"), o.find(".map-section__wrapper").html('<div class="errors text-center">' + theme.strings.authError + "</div>"));
                    };
                    var n = o.data("api-key");
                    "string" == typeof n &&
                        "" !== n &&
                        theme.loadScriptOnce("https://maps.googleapis.com/maps/api/js?key=" + n, function () {
                            t.createMap(o);
                        });
                }),
                (this.onSectionUnload = function (e) {
                    void 0 !== window.google && void 0 !== google.maps && google.maps.event.clearListeners(t.map, "resize");
                });
        })()),
        r.sections.push({ name: "map", section: theme.MapSection }),
        (theme.Popup = new (function () {
            var t = "cc-theme-popup-dismissed";
            (this.onSectionLoad = function (i) {
                (this.namespace = theme.namespaceFromSection(i)), (this.$container = e(i)), (this.popup = new h(this.$container, this.namespace));
                var o = this.$container.data("dismiss-for-days"),
                    n = this.$container.data("delay-seconds"),
                    a = !0,
                    s = this.$container.data("test-mode"),
                    r = window.localStorage.getItem(t);
                r && (new Date().getTime() - r) / 864e5 < o && (a = !1);
                this.$container.find(".cc-popup-form__response").length && ((a = !0), (n = 1), this.$container.find(".cc-popup-form__response--success").length && this.functions.popupSetAsDismissed.call(this)),
                    document.querySelector(".shopify-challenge__container") && (a = !1),
                    (a || s) &&
                        setTimeout(() => {
                            this.popup.open();
                        }, 1e3 * n),
                    this.$container.on("click" + this.namespace, ".cc-popup-close, .cc-popup-background", () => {
                        this.popup.close(() => {
                            this.functions.popupSetAsDismissed.call(this);
                        });
                    });
            }),
                (this.onSectionSelect = function () {
                    this.popup.open();
                }),
                (this.functions = {
                    popupSetAsDismissed: function () {
                        window.localStorage.setItem(t, new Date().getTime());
                    },
                }),
                (this.onSectionUnload = function () {
                    this.$container.off(this.namespace);
                });
        })()),
        r.sections.push({ name: "newsletter-popup", section: theme.Popup }),
        (theme.StoreAvailability = function (t) {
            var i = "store-availability-loading",
                o = "cc-location";
            (this.onSectionLoad = function (t) {
                (this.namespace = theme.namespaceFromSection(t)),
                    (this.$container = e(t)),
                    (this.productId = this.$container.data("store-availability-container")),
                    (this.sectionUrl = this.$container.data("section-url")),
                    this.$modal,
                    this.$container.addClass("store-availability-initialized"),
                    (this.transitionDurationMS = 1e3 * parseFloat(getComputedStyle(t).transitionDuration)),
                    (this.removeFixedHeightTimeout = -1),
                    e(window).on("cc-variant-updated".concat(this.namespace).concat(this.productId), (e, t) => {
                        t.product.id === this.productId &&
                            this.functions.updateContent.bind(this)(t.variant ? t.variant.id : null, t.product.title, this.$container.data("has-only-default-variant"), t.variant && void 0 !== t.variant.available);
                    }),
                    this.$container.data("single-variant-id") &&
                        this.functions.updateContent.bind(this)(
                            this.$container.data("single-variant-id"),
                            this.$container.data("single-variant-product-title"),
                            this.$container.data("has-only-default-variant"),
                            this.$container.data("single-variant-product-available")
                        );
            }),
                (this.onSectionUnload = function () {
                    e(window).off("cc-variant-updated".concat(this.namespace).concat(this.productId)), this.$container.off("click"), this.$modal && this.$modal.off("click");
                }),
                (this.functions = {
                    getUserLocation: function () {
                        return new Promise((e, t) => {
                            var i;
                            sessionStorage[o] && (i = JSON.parse(sessionStorage[o])),
                                i
                                    ? e(i)
                                    : navigator.geolocation
                                    ? navigator.geolocation.getCurrentPosition(
                                          function (t) {
                                              var i = { latitude: t.coords.latitude, longitude: t.coords.longitude };
                                              fetch("/localization.json", { method: "PUT", headers: { "Content-Type": "application/json" }, body: JSON.stringify(i) }), (sessionStorage[o] = JSON.stringify(i)), e(i);
                                          },
                                          function () {
                                              e(!1);
                                          },
                                          { maximumAge: 36e5, timeout: 5e3 }
                                      )
                                    : e(!1);
                        });
                    },
                    getAvailableStores: function (t, i) {
                        return e.get(this.sectionUrl.replace("VARIANT_ID", t), i);
                    },
                    calculateDistance: function (e, t, i) {
                        var o = Math.PI / 180,
                            n = "metric" === i ? 6378.14 : 3959,
                            a = e.latitude * o,
                            s = e.longitude * o,
                            r = t.latitude * o,
                            l = s - t.longitude * o,
                            c = a - r,
                            d = Math.pow(Math.sin(c / 2), 2) + Math.cos(a) * Math.cos(r) * Math.pow(Math.sin(l / 2), 2);
                        return n * (2 * Math.atan2(Math.sqrt(d), Math.sqrt(1 - d)));
                    },
                    updateLocationDistances: function (t) {
                        var i = this.$modal.find("[data-unit-system]").data("unit-system"),
                            o = this;
                        this.$modal.find('[data-distance="false"]').each(function () {
                            var n = { latitude: parseFloat(e(this).data("latitude")), longitude: parseFloat(e(this).data("longitude")) };
                            if (n.latitude && n.longitude) {
                                var a = o.functions.calculateDistance(t, n, i).toFixed(1);
                                e(this).html(a),
                                    setTimeout(() => {
                                        e(this).closest(".store-availability-list__location__distance").addClass("-in");
                                    }, 0);
                            }
                            e(this).attr("data-distance", "true");
                        });
                    },
                    updateContent: function (t, o, n, a) {
                        this.$container.off("click", "[data-store-availability-modal-open]"),
                            this.$container.off("click" + this.namespace, ".cc-popup-close, .cc-popup-background"),
                            e(".store-availabilities-modal").remove(),
                            a
                                ? (this.$container.addClass(i), this.transitionDurationMS > 0 && this.$container.css("height", this.$container.outerHeight() + "px"))
                                : (this.$container.addClass(i), this.transitionDurationMS > 0 && this.$container.css("height", "0px")),
                            a &&
                                this.functions.getAvailableStores.call(this, t, (a) => {
                                    if (a.trim().length > 0 && !a.includes("NO_PICKUP")) {
                                        this.$container.html(a),
                                            this.$container.html(this.$container.children().first().html()),
                                            this.$container.find("[data-store-availability-modal-product-title]").html(o),
                                            n && this.$container.find(".store-availabilities-modal__variant-title").remove(),
                                            this.$container.find(".cc-popup").appendTo("body"),
                                            (this.$modal = e("body").find(".store-availabilities-modal"));
                                        var s = new h(this.$modal, this.namespace);
                                        if (
                                            (this.$container.on(
                                                "click",
                                                "[data-store-availability-modal-open]",
                                                () => (
                                                    s.open(),
                                                    this.functions.getUserLocation().then((i) => {
                                                        i &&
                                                            this.$modal.find('[data-distance="false"]').length &&
                                                            this.functions.getAvailableStores.call(this, t, (t) => {
                                                                this.$modal.find(".store-availabilities-list").html(e(t).find(".store-availabilities-list").html()), this.functions.updateLocationDistances.bind(this)(i);
                                                            });
                                                    }),
                                                    !1
                                                )
                                            ),
                                            this.$modal.on("click" + this.namespace, ".cc-popup-close, .cc-popup-background", () => {
                                                s.close();
                                            }),
                                            this.$container.removeClass(i),
                                            this.transitionDurationMS > 0)
                                        ) {
                                            var r = this.$container.find(".store-availability-container").outerHeight();
                                            this.$container.css("height", r > 0 ? r + "px" : ""),
                                                clearTimeout(this.removeFixedHeightTimeout),
                                                (this.removeFixedHeightTimeout = setTimeout(() => {
                                                    this.$container.css("height", "");
                                                }, this.transitionDurationMS));
                                        }
                                    }
                                });
                    },
                }),
                this.onSectionLoad(t);
        }),
        r.sections.push({ name: "store-availability", section: theme.StoreAvailability });
    class u {
        constructor(e) {
            (this.container = e),
                (this.selectors = {
                    inputMin: ".cc-price-range__input--min",
                    inputMax: ".cc-price-range__input--max",
                    control: ".cc-price-range__control",
                    controlMin: ".cc-price-range__control--min",
                    controlMax: ".cc-price-range__control--max",
                    bar: ".cc-price-range__bar",
                    activeBar: ".cc-price-range__bar-active",
                }),
                (this.controls = {
                    min: { barControl: e.querySelector(this.selectors.controlMin), input: e.querySelector(this.selectors.inputMin) },
                    max: { barControl: e.querySelector(this.selectors.controlMax), input: e.querySelector(this.selectors.inputMax) },
                }),
                (this.controls.min.value = parseInt("" === this.controls.min.input.value ? this.controls.min.input.placeholder : this.controls.min.input.value)),
                (this.controls.max.value = parseInt("" === this.controls.max.input.value ? this.controls.max.input.placeholder : this.controls.max.input.value)),
                (this.valueMin = this.controls.min.input.min),
                (this.valueMax = this.controls.min.input.max),
                (this.valueRange = this.valueMax - this.valueMin),
                [this.controls.min, this.controls.max].forEach((e) => {
                    e.barControl.setAttribute("aria-valuemin", this.valueMin), e.barControl.setAttribute("aria-valuemax", this.valueMax);
                }),
                this.controls.min.barControl.setAttribute("aria-valuenow", this.controls.min.value),
                this.controls.max.barControl.setAttribute("aria-valuenow", this.controls.max.value),
                (this.bar = e.querySelector(this.selectors.bar)),
                (this.activeBar = e.querySelector(this.selectors.activeBar)),
                (this.inDrag = !1),
                this.bindEvents(),
                this.render();
        }
        getPxToValueRatio() {
            return this.bar.clientWidth / (this.valueMax - this.valueMin);
        }
        getPcToValueRatio() {
            return 100 / (this.valueMax - this.valueMin);
        }
        setActiveControlValue(e, t) {
            this.activeControl === this.controls.min
                ? ("" === e && (e = this.valueMin), (e = Math.max(this.valueMin, e)), (e = Math.min(e, this.controls.max.value)))
                : ("" === e && (e = this.valueMax), (e = Math.min(this.valueMax, e)), (e = Math.max(e, this.controls.min.value))),
                (this.activeControl.value = Math.round(e)),
                this.activeControl.input.value != this.activeControl.value &&
                    (this.activeControl.value == this.activeControl.input.placeholder ? (this.activeControl.input.value = "") : (this.activeControl.input.value = this.activeControl.value),
                    t || this.activeControl.input.dispatchEvent(new CustomEvent("change", { bubbles: !0, detail: { sender: "theme:component:price_range" } }))),
                this.activeControl.barControl.setAttribute("aria-valuenow", this.activeControl.value);
        }
        render() {
            this.drawControl(this.controls.min), this.drawControl(this.controls.max), this.drawActiveBar();
        }
        drawControl(e) {
            e.barControl.style.left = "".concat((e.value - this.valueMin) * this.getPcToValueRatio(), "%");
        }
        drawActiveBar() {
            (this.activeBar.style.left = "".concat((this.controls.min.value - this.valueMin) * this.getPcToValueRatio(), "%")),
                (this.activeBar.style.right = "".concat((this.valueMax - this.controls.max.value) * this.getPcToValueRatio(), "%"));
        }
        handleControlTouchStart(e) {
            e.preventDefault(),
                this.startDrag(e.target, e.touches[0].clientX),
                (this.boundControlTouchMoveEvent = this.handleControlTouchMove.bind(this)),
                (this.boundControlTouchEndEvent = this.handleControlTouchEnd.bind(this)),
                window.addEventListener("touchmove", this.boundControlTouchMoveEvent),
                window.addEventListener("touchend", this.boundControlTouchEndEvent);
        }
        handleControlTouchMove(e) {
            this.moveDrag(e.touches[0].clientX);
        }
        handleControlTouchEnd(e) {
            e.preventDefault(), window.removeEventListener("touchmove", this.boundControlTouchMoveEvent), window.removeEventListener("touchend", this.boundControlTouchEndEvent), this.stopDrag();
        }
        handleControlMouseDown(e) {
            e.preventDefault(),
                this.startDrag(e.target, e.clientX),
                (this.boundControlMouseMoveEvent = this.handleControlMouseMove.bind(this)),
                (this.boundControlMouseUpEvent = this.handleControlMouseUp.bind(this)),
                window.addEventListener("mousemove", this.boundControlMouseMoveEvent),
                window.addEventListener("mouseup", this.boundControlMouseUpEvent);
        }
        handleControlMouseMove(e) {
            this.moveDrag(e.clientX);
        }
        handleControlMouseUp(e) {
            e.preventDefault(), window.removeEventListener("mousemove", this.boundControlMouseMoveEvent), window.removeEventListener("mouseup", this.boundControlMouseUpEvent), this.stopDrag();
        }
        startDrag(e, t) {
            (this.activeControl = this.controls.min.barControl === e ? this.controls.min : this.controls.max), (this.dragStartX = t), (this.dragStartValue = this.activeControl.value), (this.inDrag = !0);
        }
        moveDrag(e) {
            if (this.inDrag) {
                var t = this.dragStartValue + (e - this.dragStartX) / this.getPxToValueRatio();
                this.setActiveControlValue(t), this.render();
            }
        }
        stopDrag() {
            this.inDrag = !1;
        }
        handleInputChange(e) {
            if ("INPUT" === e.target.tagName && (!e.detail || "theme:component:price_range" !== e.detail.sender)) {
                var t = e.detail && "reset" === e.detail.sender;
                (this.activeControl = this.controls.min.input === e.target ? this.controls.min : this.controls.max), this.setActiveControlValue(e.target.value, t), this.render();
            }
        }
        bindEvents() {
            [this.controls.min, this.controls.max].forEach((e) => {
                e.barControl.addEventListener("touchstart", this.handleControlTouchStart.bind(this)), e.barControl.addEventListener("mousedown", this.handleControlMouseDown.bind(this));
            }),
                this.container.addEventListener("change", this.handleInputChange.bind(this));
        }
        destroy() {}
    }
    new (class extends l {
        constructor() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "price-range";
            super(e, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : ".cc-".concat(e));
        }
        init(e) {
            super.init(e), this.registerInstance(e, new u(e));
        }
        destroy(e) {
            this.destroyInstance(e), super.destroy(e);
        }
    })(),
        (theme.icons = {
            chevronLightLeft: '<svg fill="currentColor" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M 14.51,6.51 14,6 8,12 14,18 14.51,17.49 9.03,12 Z"></path></svg>',
            chevronLightRight: '<svg fill="currentColor" viewBox="0 0 24 24" height="24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M 10,6 9.49,6.51 14.97,12 9.49,17.49 10,18 16,12 Z"></path></svg>',
            arrowLeft:
                '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-left"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>',
            arrowRight:
                '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>',
            close:
                '<svg fill="currentColor" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path></svg>',
        }),
        (theme.viewport = { isXs: () => e(window).outerWidth() < 768, isSm: () => e(window).outerWidth() >= 768, isMd: () => e(window).outerWidth() >= 992 }),
        (theme.nav = {
            bar: {
                isInlineNavEnabled: () => e(".pageheader__contents[data-nav-inline]").length > 0,
                changeToInline: () => {
                    e(".pageheader__contents").addClass("pageheader__contents--inline--visible");
                },
                changeToBurger: () => {
                    e(".pageheader__contents").removeClass("pageheader__contents--inline--visible");
                },
                height: () => e(".pageheader__contents").outerHeight(),
            },
        }),
        (theme.lightbox_min_window_width = 768),
        (theme.lightbox_min_window_height = 580);
    try {
        theme.Shopify.features = JSON.parse(document.documentElement.querySelector("#shopify-features").textContent);
    } catch (e) {
        theme.Shopify.features = {};
    }
    (theme.debounce = (e, t) => {
        var i;
        return function () {
            for (var o = arguments.length, n = new Array(o), a = 0; a < o; a++) n[a] = arguments[a];
            clearTimeout(i), (i = setTimeout(() => e.apply(s, n), t));
        };
    }),
        (theme.checkMenuPadding = function () {
            if (e("html").hasClass("open-menu")) {
                var t = e("#shopify-section-announcement"),
                    i = parseInt(theme.nav.bar.height() / 2) + 42;
                t && !e("body").hasClass("scrolled-down") && (i += parseInt(t.outerHeight())), i > 90 ? e("#main-menu").css("border-top-width", i + "px") : e("#main-menu").removeAttr("style");
            }
        }),
        (theme.buildGalleryViewer = function (t) {
            for (
                var i = e('<div class="gallery-viewer gallery-viewer--pre-reveal">'),
                    o = e('<div class="gallery-viewer__zoom">').appendTo(i),
                    n = e('<div class="gallery-viewer__thumbs">').appendTo(i),
                    a = e('<div class="gallery-viewer__controls">').appendTo(i),
                    s =
                        (e('<a class="gallery-viewer__button gallery-viewer__close" href="#">').attr("aria-label", theme.strings.close).html(t.close).appendTo(a),
                        e('<a class="gallery-viewer__button gallery-viewer__prev" href="#">').attr("aria-label", theme.strings.previous).html(t.prev).appendTo(a),
                        e('<a class="gallery-viewer__button gallery-viewer__next" href="#">').attr("aria-label", theme.strings.next).html(t.next).appendTo(a),
                        null),
                    r = 0;
                r < t.images.length;
                r++
            ) {
                var l = t.images[r];
                e('<a class="gallery-viewer__thumb" href="#">').data("zoom-url", l.zoomUrl).html(l.thumbTag).appendTo(n);
            }
            1 === t.images.length && i.addClass("gallery-viewer--single-image");
            var c = function (e, t) {
                    var o = s.width() > i.width(),
                        n = s.height() > i.height();
                    if (o || n) {
                        var a = i.width() / 2,
                            r = i.height() / 2,
                            l = e - a,
                            c = t - r,
                            d = 0,
                            h = 0;
                        if (o) {
                            var u = (s.width() - i.width()) / 2 / a;
                            d = Math.round(-l * u);
                        }
                        if (n) {
                            var p = (s.height() - i.height()) / 2 / r;
                            h = Math.round(-c * p);
                        }
                        s.css("transform", ["translate3d(", d, "px, ", h, "px, 0)"].join(""));
                    }
                },
                d = function (e) {
                    e.preventDefault();
                    var t = n.find(".gallery-viewer__thumb--active").next();
                    0 === t.length && (t = n.find(".gallery-viewer__thumb:first")), t.trigger("select");
                },
                h = function (e) {
                    e.preventDefault();
                    var t = n.find(".gallery-viewer__thumb--active").prev();
                    0 === t.length && (t = n.find(".gallery-viewer__thumb:last")), t.trigger("select");
                },
                u = function (t) {
                    t.preventDefault(), i.off(".galleryViewer"), i.addClass("gallery-viewer--transition-out");
                    var o = i.css("transition-duration");
                    (o = o.indexOf("ms") > -1 ? parseFloat(o) : 1e3 * parseFloat(o)),
                        setTimeout(function () {
                            i.remove(), e("html").removeClass("gallery-viewer-open");
                        }, o);
                };
            i.on("click.galleryViewer select.galleryViewer", ".gallery-viewer__thumb", function (n) {
                n.preventDefault(),
                    e(this).addClass("gallery-viewer__thumb--active").siblings(".gallery-viewer__thumb--active").removeClass("gallery-viewer__thumb--active"),
                    (s = e('<img class="gallery-viewer__zoom-image" alt="" style="visibility: hidden">'))
                        .on("load", function () {
                            e(this).off("load"),
                                t.zoom
                                    ? (e(this).css({ visibility: "", top: i.height() / 2 - e(this).height() / 2, left: i.width() / 2 - e(this).width() / 2 }), c(n.clientX, n.clientY))
                                    : e(this).css({ visibility: "", width: "100%", height: "100%", objectFit: "contain", transform: "none" });
                        })
                        .attr("src", e(this).data("zoom-url")),
                    o.html(s);
            }),
                i.on("mousemove.galleryViewer touchmove.galleryViewer", function (e) {
                    if ("touchmove" === e.type) {
                        var t = e.touches[0];
                        c(t.clientX, t.clientY);
                    } else c(e.clientX, e.clientY);
                }),
                i.on("touchmove.galleryViewer", ".gallery-viewer__thumbs", function (e) {
                    e.stopPropagation();
                }),
                i.on("click.galleryViewer", ".gallery-viewer__next", d),
                i.on("click.galleryViewer", ".gallery-viewer__prev", h),
                i.on("click.galleryViewer", ".gallery-viewer__close", u),
                i.on("keydown.galleryViewer", function (e) {
                    39 === e.which ? d(e) : 37 === e.which ? h(e) : 27 === e.which && u(e);
                }),
                e("html").removeClass("gallery-viewer-open"),
                e(".gallery-viewer").remove(),
                e("html").addClass("gallery-viewer-open"),
                i.attr("tabindex", -1).appendTo("body").focus(),
                n.find(".gallery-viewer__thumb:eq(" + (t.current > 0 ? t.current : 0) + ")").trigger("select"),
                setTimeout(function () {
                    i.removeClass("gallery-viewer--pre-reveal");
                }, 10);
        }),
        (theme.ProductMediaGallery = function (t) {
            var i = this,
                o = {},
                n = t.find(".product-media"),
                a = t.find(".product-media--image:first-of-type"),
                s = t.find(".thumbnails__scroller"),
                r = t.find(".view-in-space"),
                l = !1;
            t.addClass("media-gallery--initialized"),
                (this.Image = function (e) {
                    (this.show = function () {
                        e.show();
                    }),
                        (this.destroy = function () {}),
                        (this.pause = function () {}),
                        (this.hide = function () {
                            e.hide();
                        }),
                        this.show();
                }),
                (this.Video = function (t, n) {
                    var a = this,
                        s = { play: function () {}, pause: function () {}, destroy: function () {} },
                        r = t.find("video")[0];
                    (this.show = function () {
                        t.show();
                    }),
                        (this.play = function () {
                            a.show(), s.play();
                        }),
                        (this.pause = function () {
                            s.pause();
                        }),
                        (this.hide = function () {
                            s.pause(), t.hide();
                        }),
                        (this.destroy = function () {
                            s.destroy(), e(r).off("playing", i.pauseAllMedia);
                        }),
                        theme.loadStyleOnce("https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css"),
                        window.Shopify.loadFeatures([
                            {
                                name: "video-ui",
                                version: "1.0",
                                onLoad: function () {
                                    (s = {
                                        playerType: "html5",
                                        element: r,
                                        plyr: new Shopify.Plyr(r, {
                                            controls: ["play", "progress", "mute", "volume", "play-large", "fullscreen"],
                                            loop: { active: t.data("enable-video-looping") },
                                            autoplay: e(window).width() >= 768 && n,
                                            hideControlsOnPause: !0,
                                            iconUrl: "//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.svg",
                                            tooltips: { controls: !1, seek: !0 },
                                        }),
                                        play: function () {
                                            this.plyr.play();
                                        },
                                        pause: function () {
                                            this.plyr.pause();
                                        },
                                        destroy: function () {
                                            this.plyr.destroy();
                                        },
                                    }),
                                        t.addClass("product-media--video-loaded"),
                                        (o[t.data("media-id")] = a);
                                }.bind(this),
                            },
                        ]),
                        e(r).on("playing", function () {
                            i.pauseAllMedia(t.data("media-id"));
                        }),
                        a.show();
                }),
                (this.ExternalVideo = function (t, n) {
                    var a = this,
                        s = { play: function () {}, pause: function () {}, destroy: function () {} },
                        r = t.find("iframe")[0];
                    if (
                        ((this.play = function () {
                            a.show(), s.play();
                        }),
                        (this.pause = function () {
                            s.pause();
                        }),
                        (this.show = function () {
                            t.show();
                        }),
                        (this.hide = function () {
                            s.pause(), t.hide();
                        }),
                        (this.destroy = function () {
                            s.destroy();
                        }),
                        /^(https?:\/\/)?(www\.)?(youtube\.com|youtube-nocookie\.com|youtu\.?be)\/.+$/.test(r.src))
                    ) {
                        var c = function () {
                            s = {
                                playerType: "youtube",
                                element: r,
                                player: new YT.Player(r, {
                                    videoId: t.data("video-id"),
                                    events: {
                                        onReady: function () {
                                            (o[t.data("media-id")] = a), t.addClass("product-media--video-loaded"), n && e(window).width() >= 768 && a.play();
                                        },
                                        onStateChange: function (e) {
                                            1 === e.data && i.pauseAllMedia(t.data("media-id")), 0 === e.data && t.data("enable-video-looping") && e.target.seekTo(0);
                                        },
                                    },
                                }),
                                play: function () {
                                    this.player.playVideo();
                                },
                                pause: function () {
                                    this.player.pauseVideo();
                                },
                                destroy: function () {
                                    this.player.destroy();
                                },
                            };
                        };
                        if (window.YT && window.YT.Player) c();
                        else {
                            var d = window.onYouTubeIframeAPIReady;
                            (window.onYouTubeIframeAPIReady = function () {
                                d(), c();
                            }),
                                theme.loadScriptOnce("https://www.youtube.com/iframe_api");
                        }
                    } else if (/vimeo\.com/.test(r.src)) {
                        !(function i() {
                            l
                                ? (t.data("enable-video-looping") && (r.src = r.src + "&loop=1"),
                                  n && e(window).width() >= 768 && (r.src = r.src + "&autoplay=1"),
                                  (s = {
                                      playerType: "vimeo",
                                      element: r,
                                      player: new Vimeo.Player(r),
                                      play: function () {
                                          this.player.play();
                                      },
                                      pause: function () {
                                          this.player.pause();
                                      },
                                      destroy: function () {
                                          this.player.destroy();
                                      },
                                  }).player
                                      .ready()
                                      .then(function () {
                                          (o[t.data("media-id")] = a), t.addClass("product-media--video-loaded");
                                      }))
                                : theme.loadScriptOnce("https://player.vimeo.com/api/player.js", function () {
                                      (l = !0), i();
                                  });
                        })();
                    }
                    a.show();
                }),
                (this.Model = function (i, n, a) {
                    var s = this,
                        l = { play: function () {}, pause: function () {}, destroy: function () {} },
                        c = i.find("model-viewer")[0];
                    (this.show = function () {
                        i.show(), window.ShopifyXR && r.length && (r.attr("data-shopify-model3d-id", i.data("media-id")), window.ShopifyXR.setupXRElements());
                    }),
                        (this.play = function () {
                            s.show(), l.play();
                        }),
                        (this.pause = function () {
                            l.pause();
                        }),
                        (this.hide = function () {
                            l.pause(),
                                i.hide(),
                                window.ShopifyXR && r.length && (r.attr("data-shopify-model3d-id", r.data("shopify-model3d-first-id")), r.attr("data-shopify-title", r.data("shopify-first-title")), window.ShopifyXR.setupXRElements());
                        }),
                        (this.destroy = function () {}),
                        (this.initAugmentedReality = function () {
                            if (e(".model-json", t).length) {
                                window.Shopify.loadFeatures([
                                    {
                                        name: "shopify-xr",
                                        version: "1.0",
                                        onLoad: function i() {
                                            window.ShopifyXR
                                                ? (window.ShopifyXR.addModels(JSON.parse(e(".model-json", t).html())), window.ShopifyXR.setupXRElements())
                                                : document.addEventListener("shopify_xr_initialized", function e(t) {
                                                      i(), t.target.removeEventListener(t.type, e);
                                                  });
                                        },
                                    },
                                ]);
                            }
                        }),
                        theme.loadStyleOnce("https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css"),
                        window.Shopify.loadFeatures([
                            {
                                name: "model-viewer-ui",
                                version: "1.0",
                                onLoad: function () {
                                    (l = new Shopify.ModelViewerUI(c)), i.addClass("product-media--model-loaded"), n && e(window).width() >= 768 && s.play(), i.find("button").attr("type", "button");
                                }.bind(this),
                            },
                        ]),
                        (o[i.data("media-id")] = s),
                        a || s.show(),
                        window.ShopifyXR || s.initAugmentedReality();
                }),
                (this.pauseAllMedia = function (e) {
                    for (var t in o) !o.hasOwnProperty(t) || (e && t == e) || o[t].pause();
                }),
                (this.showMedia = function (n, s, r) {
                    if (n.length) {
                        a && !r && a.hide();
                        var l = function (t) {
                            var i;
                            return o.hasOwnProperty(n.data("media-id")) ? ((i = o[n.data("media-id")]), s && e(window).width() >= 768 ? (i.show(), setTimeout(i.play, 250)) : i.show()) : (i = new t(n, s)), i;
                        };
                        "image" === n.data("media-type")
                            ? (a = l(i.Image))
                            : "video" === n.data("media-type")
                            ? (a = l(i.Video))
                            : "external_video" === n.data("media-type")
                            ? (a = l(i.ExternalVideo))
                            : "model" === n.data("media-type")
                            ? (a = l(i.Model))
                            : (console.warn("Media is unknown", n), t.find(".product-media:visible").hide(), n.show());
                    }
                }),
                (this.destroy = function () {
                    for (var i = 0; i < o.length; i++) o[i].destroy();
                    t.off("click"), e(window).off("debouncedresize.gallery", v);
                });
            var c = t.find(".thumb.is-active"),
                d = t.find(".product-media:first");
            if ((c.length && (d = t.find('.product-media[data-media-id="' + c.data("media-id") + '"]')), this.showMedia(d, !1), "model" !== d.data("media-type") && e(window).width() < 768)) {
                var h = t.find('.product-media[data-media-type="model"]:first');
                h.length && new i.Model(h, !1, !0);
            }
            if (s.length) {
                t.on("click", ".thumb", function (o) {
                    if ((o.preventDefault(), !e(this).hasClass("is-active"))) {
                        var n = t.find('.product-media[data-media-id="' + e(this).data("media-id") + '"]');
                        t.hasClass("media-gallery--expanded")
                            ? e("html, body").animate({ scrollTop: n.offset().top - 90 }, 500, "swing")
                            : (i.showMedia(n, !0), c.removeClass("is-active"), (c = e(this).addClass("is-active")), n.addClass("is-active").siblings(".is-active").removeClass("is-active").hide());
                    }
                }),
                    t.on("click", ".thumbnails__prev,.thumbnails__next", function (t) {
                        t.preventDefault(),
                            window.innerWidth >= 992
                                ? e(this).hasClass("thumbnails__prev")
                                    ? s.animate({ scrollTop: s.scrollTop() - 0.8 * s.outerHeight() }, 500)
                                    : s.animate({ scrollTop: 0.8 * s.outerHeight() + s.scrollTop() }, 500)
                                : e(this).hasClass("thumbnails__prev")
                                ? s.animate({ scrollLeft: s.scrollLeft() - 0.8 * s.outerWidth() }, 500)
                                : s.animate({ scrollLeft: 0.8 * s.outerWidth() + s.scrollLeft() }, 500);
                    });
                var u,
                    p = t.find(".thumbnails__prev"),
                    m = t.find(".thumbnails__next"),
                    f = s.find(".thumbnails__thumbs");
                function v() {
                    var e = f.outerWidth() < s.outerWidth(),
                        t = 0 === s.scrollLeft(),
                        i = s.innerWidth() + s.scrollLeft() === f.outerWidth();
                    window.innerWidth >= 992 && ((e = f.outerHeight() < s.outerHeight()), (t = 0 === s.scrollTop()), (i = s.innerHeight() + s.scrollTop() === Math.round(f.outerHeight()))),
                        e ? ((p[0].disabled = !0), (m[0].disabled = !0)) : t ? ((p[0].disabled = !0), (m[0].disabled = !1)) : i ? ((p[0].disabled = !1), (m[0].disabled = !0)) : ((p[0].disabled = !1), (m[0].disabled = !1));
                }
                v(),
                    s.scroll(function () {
                        clearTimeout(u), (u = setTimeout(v, 100));
                    }),
                    e(window).on("debouncedresize.gallery", v);
            }
            var y = t.parent().find(".expand-media-btn");
            y.length &&
                y.on("click", function () {
                    t.toggleClass("media-gallery--expanded"),
                        t.hasClass("media-gallery--expanded")
                            ? n.each(function () {
                                  i.showMedia(e(this), !1, !0);
                              })
                            : (n.each(function () {
                                  e(this).data("media-id") !== c.data("media-id") && e(this).hide();
                              }),
                              e("html, body").animate({ scrollTop: 0 }, 500, "swing"));
                }),
                t.on("click", ".product-media__link", function (i) {
                    i.preventDefault();
                    var o = [],
                        n = 0,
                        a = t.find(".thumb--media-image");
                    if (a.length) {
                        var s = i.currentTarget.closest(".product-media").dataset.mediaId;
                        a.each(function () {
                            var t = e(this).find(".thumb__image").clone();
                            o.push({ thumbTag: t, zoomUrl: e(this).attr("href") });
                        }),
                            a.each(function (e) {
                                this.dataset.mediaId !== s || (n = e);
                            });
                    } else {
                        var r = e(this).find(".thumb__image").clone();
                        o.push({ thumbTag: r, zoomUrl: e(this).attr("href") });
                    }
                    theme.buildGalleryViewer({ images: o, current: n, zoom: e(this).data("enable-zoom"), prev: theme.icons.arrowLeft, next: theme.icons.arrowRight, close: theme.icons.close });
                });
        }),
        (theme.applyAjaxToProductForm = function (t) {
            var i = theme.routes.cart_add_url + ".js",
                o = theme.routes.search_url;
            t.filter('[data-ajax-add-to-cart="true"]').on("submit", function (t) {
                t.preventDefault();
                var n = e(this);
                n
                    .find('button[type="submit"]')
                    .attr("disabled", "disabled")
                    .each(function () {
                        e(this).data("previous-value", e(this).html()).html(theme.strings.addingToCart);
                    }),
                    e
                        .post(
                            i,
                            n.serialize(),
                            function (t) {
                                n.find('button[type="submit"]').each(function () {
                                    var t = e(this);
                                    t.html(theme.strings.addedToCart),
                                        setTimeout(function () {
                                            t.removeAttr("disabled").html(t.data("previous-value"));
                                        }, 4e3);
                                }),
                                    e.get(o, function (t) {
                                        for (var i = e(e.parseHTML("<div>" + t + "</div>")), o = [".pageheader .header-items"], n = 0; n < o.length; n++) {
                                            var a = o[n],
                                                s = i.find(a);
                                            e(a).replaceWith(s);
                                        }
                                    });
                            },
                            "text"
                        )
                        .fail(function (t) {
                            var i = n
                                .find('button[type="submit"]')
                                .removeAttr("disabled")
                                .each(function () {
                                    e(this).html(e(this).data("previous-value"));
                                })
                                .first();
                            if (void 0 !== t && void 0 !== t.status) {
                                var o = e.parseJSON(t.responseText);
                                theme.showQuickPopup(o.description, i);
                            } else n.attr("ajax-add-to-cart", "false").submit();
                        });
            });
        }),
        (theme.removeAjaxFromProductForm = function (e) {
            e.off("submit");
        }),
        (theme.ProductResultsSection = new (function () {
            var e = this;
            (this.onSectionLoad = (e) => {
                if (
                    ((this.filteringEnabled = "true" === e.dataset.filtering),
                    (this.sortingEnabled = "true" === e.dataset.sorting),
                    (this.resultsCountEl = document.getElementById("results-count")),
                    (this.resultsListEl = document.querySelector(".filters-results")),
                    (this.filteringEnabled || this.sortingEnabled) && this.resultsListEl)
                ) {
                    if (this.filteringEnabled) {
                        var t = document.querySelector(".js-show-filters"),
                            i = document.querySelector(".js-hide-filters"),
                            o = document.querySelector(".js-reset-filters");
                        (this.filtersForm = document.getElementById("filters")),
                            (this.filtersEl = document.querySelector(".filters")),
                            (this.filterEls = document.querySelectorAll(".js-filter")),
                            (this.activeFiltersEl = document.querySelector(".active-filters")),
                            (this.resultsBtn = document.querySelector(".js-apply-filters")),
                            (this.filtersOpen = this.filtersEl.dataset.filtersOpen),
                            t.addEventListener("click", this.toggleFilters.bind(this)),
                            i.addEventListener("click", this.toggleFilters.bind(this)),
                            o.addEventListener("click", (e) => {
                                e.preventDefault(), this.applyFilters(new URL(e.target.href).searchParams.toString(), e);
                            }),
                            this.filtersEl.addEventListener("input", theme.debounce(this.handleFilterChange.bind(this), 500)),
                            this.filtersEl.addEventListener("change", theme.debounce(this.handleFilterChange.bind(this), 500)),
                            this.activeFiltersEl.addEventListener("click", this.handleActiveFiltersClick.bind(this)),
                            this.resultsBtn.addEventListener("click", this.toggleFilters.bind(this)),
                            window.addEventListener("popstate", this.handleHistoryChange.bind(this)),
                            window.addEventListener("resize", theme.debounce(this.handleWindowResize.bind(this), 500)),
                            this.handleWindowResize();
                    }
                    if (this.sortingEnabled) {
                        this.desktopSortBy = document.getElementById("sort-by");
                        var n = document.getElementById("mobile-sort-by");
                        this.desktopSortBy.addEventListener("change", (e) => {
                            n && (n.querySelector('input[value="'.concat(e.detail.selectedValue, '"]')).checked = !0), this.handleSortChange(e);
                        });
                    }
                }
            }),
                (this.toggleFilters = (e) => {
                    var t = !1;
                    e && (e.preventDefault(), (t = e.target.classList.contains("js-show-filters"))), document.documentElement.classList.toggle("open-side-drawer", t), this.filteringEnabled && this.filtersEl.classList.toggle("is-open", t);
                }),
                (this.handleFilterChange = (e) => {
                    if ("change" !== e.type || (e.detail && "theme:component:price_range" === e.detail.sender)) {
                        "input" == e.type && e.target.classList.contains("cc-price-range__input") && e.target.dispatchEvent(new Event("change", { bubbles: !0 }));
                        var t = new FormData(this.filtersForm),
                            i = new URLSearchParams(t);
                        this.applyFilters(i.toString(), e);
                    }
                }),
                (this.handleSortChange = (e) => {
                    var t;
                    if (this.filteringEnabled) {
                        var i = new FormData(this.filtersForm);
                        t = new URLSearchParams(i);
                    } else {
                        var o = this.desktopSortBy.querySelector('[aria-selected="true"]');
                        (t = new URLSearchParams(window.location.search)).set("sort_by", o.dataset.value);
                    }
                    this.applyFilters(t.toString(), e);
                }),
                (this.handleActiveFiltersClick = (e) => {
                    e.preventDefault(), "A" === e.target.tagName && this.applyFilters(new URL(e.target.href).searchParams.toString(), e);
                }),
                (this.handleHistoryChange = (e) => {
                    var t = "";
                    e.state && e.state.searchParams && (t = e.state.searchParams), this.applyFilters(t, null, !1);
                }),
                (this.handleWindowResize = () => {
                    window.innerWidth < 768
                        ? this.filterEls.forEach((e) => {
                              (e.open = !1), e.classList.remove("is-open");
                          })
                        : this.filterEls.forEach((e, t) => {
                              ("all" === this.filtersOpen || ("some" === this.filtersOpen && t < 5)) && ((e.open = !0), e.classList.add("is-open"));
                          });
                }),
                (this.applyFilters = function (t, i) {
                    var o = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
                    e.resultsListEl.classList.add("is-loading"),
                        fetch("".concat(window.location.pathname, "?").concat(t))
                            .then((e) => e.text())
                            .then((t) => {
                                var o = document.implementation.createHTMLDocument();
                                (o.documentElement.innerHTML = t),
                                    e.updateFilters(o, i),
                                    (e.resultsListEl.innerHTML = o.querySelector(".filters-results").innerHTML),
                                    e.resultsCountEl && (e.resultsCountEl.innerHTML = o.getElementById("results-count").innerHTML),
                                    e.resultsListEl.classList.remove("is-loading");
                            }),
                        o && e.updateURL(t);
                }),
                (this.updateFilters = (e, t) => {
                    if ((t && "radio" === t.target.type && "sort_by" === t.target.name && this.updateSortByDropdown(t.target.value), this.filteringEnabled)) {
                        var i = e.querySelectorAll(".js-filter");
                        Array.from(i)
                            .filter(
                                (e) =>
                                    !((e) => {
                                        if (!t) return !1;
                                        var i = t.target.closest(".js-filter");
                                        return !!i && e.dataset.index === i.dataset.index;
                                    })(e)
                            )
                            .forEach((i) => {
                                var o = document.querySelector('.js-filter[data-index="'.concat(i.dataset.index, '"]'));
                                "price_range" === o.dataset.type
                                    ? (t && "INPUT" === t.target.tagName) ||
                                      o.querySelectorAll("input").forEach((t) => {
                                          (t.value = e.getElementById(t.id).value), t.dispatchEvent(new CustomEvent("change", { bubbles: !0, detail: { sender: "reset" } }));
                                      })
                                    : (o.innerHTML = i.innerHTML);
                            }),
                            this.updateActiveFilters(e),
                            (this.resultsBtn.textContent = e.querySelector(".js-apply-filters").innerHTML);
                    }
                }),
                (this.updateActiveFilters = (e) => {
                    (this.activeFiltersEl.innerHTML = e.querySelector(".active-filters").innerHTML), (this.activeFiltersEl.hidden = !this.activeFiltersEl.querySelector(".active-filters__item"));
                }),
                (this.updateURL = (e) => {
                    history.pushState({ searchParams: e }, "", "".concat(window.location.pathname).concat(e && "?".concat(e)));
                }),
                (this.updateSortByDropdown = (e) => {
                    var t = this.desktopSortBy.querySelector('[aria-selected="true"]'),
                        i = this.desktopSortBy.querySelector('[data-value="'.concat(e, '"'));
                    (this.desktopSortBy.querySelector(".cc-select__btn").firstChild.textContent = i.textContent),
                        this.desktopSortBy.querySelector(".cc-select__listbox").setAttribute("aria-activedescendant", i.id),
                        t.setAttribute("aria-selected", "false"),
                        i.setAttribute("aria-selected", "true");
                }),
                (this.onSectionUnload = () => {
                    this.toggleFilters();
                });
        })()),
        (theme.productData = {}),
        (theme.OptionManager = new (function () {
            var t = this;
            (t._getVariantOptionElement = function (e, t) {
                return t.find('select[name="id"] option[value="' + e.id + '"]');
            }),
                (t.selectors = { container: ".product", gallery: ".media-gallery", priceArea: ".product-price", submitButton: "input[type=submit], button[type=submit]", multiOption: ".product-options" }),
                (t.strings = {
                    priceNonExistent: theme.strings.priceNonExistent,
                    priceSoldOut: '<span class="productlabel soldout"><span>' + theme.strings.buttonNoStock + "</span></span>",
                    buttonDefault: theme.strings.buttonDefault,
                    buttonNoStock: theme.strings.buttonNoStock,
                    buttonNoVariant: theme.strings.buttonNoVariant,
                    unitPriceSeparator: theme.strings.products_product_unit_price_separator,
                    inventoryNotice: theme.strings.onlyXLeft,
                }),
                (t._getString = function (e, i) {
                    var o = t.strings[e];
                    return i && (o = o.replace("[PRICE]", '<span class="product-price__amount theme-money">' + theme.Shopify.formatMoney(i.price, theme.money_format) + "</span>")), o;
                }),
                (t.getProductData = function (e) {
                    var t;
                    return theme.productData[e] || (theme.productData[e] = JSON.parse(document.getElementById("ProductJson-" + e).innerHTML)), (t = theme.productData[e]) || console.log("Product data missing (id: " + e + ")"), t;
                }),
                (t.getBaseUnit = function (e) {
                    return 1 === e.unit_price_measurement.reference_value ? e.unit_price_measurement.reference_unit : e.unit_price_measurement.reference_value + e.unit_price_measurement.reference_unit;
                }),
                (t.addVariantUrlToHistory = function (e) {
                    if (e) {
                        var t = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + e.id;
                        window.history.replaceState({ path: t }, "", t);
                    }
                }),
                (t.updateSku = function (e, t) {
                    t.find(".sku .sku__value").html(e ? e.sku : ""), t.find(".sku").toggleClass("sku--no-sku", !e || !e.sku);
                }),
                (t.updateBarcode = function (e, t) {
                    t.find(".barcode .barcode__value").html(e ? e.barcode : ""), t.find(".barcode").toggleClass("barcode--no-barcode", !e || !e.barcode);
                }),
                (t.updateInventoryNotice = function (e, i) {
                    var o = t._getVariantOptionElement(e, i).data("inventory");
                    o
                        ? i.find(".product-inventory-notice").removeClass("product-inventory-notice--no-inventory").html(t._getString("inventoryNotice").replace("[[ quantity ]]", o))
                        : i.find(".product-inventory-notice").addClass("product-inventory-notice--no-inventory").empty();
                }),
                (t.updateBackorder = function (e, i) {
                    var o = i.find(".backorder");
                    if (o.length)
                        if (e && e.available)
                            if (e.inventory_management && "out" == t._getVariantOptionElement(e, i).data("stock")) {
                                var n = t.getProductData(i.data("product-id"));
                                o.find(".backorder__variant").html(n.title + (e.title.indexOf("Default") >= 0 ? "" : " - " + e.title)), o.show();
                            } else o.hide();
                        else o.hide();
                }),
                (t.updatePrice = function (i, o) {
                    var n = o.find(t.selectors.priceArea);
                    if (n.length) {
                        if ((n.removeClass("on-sale"), i && 1 == i.available)) {
                            var a = e("<div>");
                            if (
                                (e('<span class="product-price__amount theme-money">').html(theme.Shopify.formatMoney(i.price, theme.money_format)).appendTo(a),
                                i.compare_at_price > i.price &&
                                    (a.append(" "), e('<span class="product-price__compare theme-money">').html(theme.Shopify.formatMoney(i.compare_at_price, theme.money_format)).appendTo(a), n.addClass("on-sale")),
                                i.unit_price_measurement)
                            ) {
                                var s = e('<div class="unit-price">').appendTo(a);
                                e('<span class="unit-price__price theme-money">').html(theme.Shopify.formatMoney(i.unit_price, theme.money_format)).appendTo(s),
                                    e('<span class="unit-price__separator">').html(t._getString("unitPriceSeparator")).appendTo(s),
                                    e('<span class="unit-price__unit">').html(t.getBaseUnit(i)).appendTo(s);
                            }
                            n.html(a.html());
                        } else i ? n.html(t._getString("priceSoldOut", i)) : n.html(t._getString("priceNonExistent", i));
                        var r = o[0].querySelector('input[name="id"]');
                        (r.value = i.id), r.dispatchEvent(new Event("change", { bubbles: !0 }));
                    }
                }),
                (t._updateButtonText = function (i, o, n) {
                    i.each(function () {
                        var i;
                        !1 !== (i = t._getString("button" + o, n)) && (e(this).is("input") ? e(this).val(i) : e(this).html(i));
                    });
                }),
                (t.updateButtons = function (e, i) {
                    var o = i.find(t.selectors.submitButton);
                    e && 1 == e.available ? (o.removeAttr("disabled"), t._updateButtonText(o, "Default", e)) : (o.attr("disabled", "disabled"), e ? t._updateButtonText(o, "NoStock", e) : t._updateButtonText(o, "NoVariant", e));
                }),
                (t.updateContainerStatusClasses = function (e, i) {
                    i.toggleClass("variant-status--unavailable", !e.available), i.toggleClass("variant-status--backorder", e.available && e.inventory_management && "out" == t._getVariantOptionElement(e, i).data("stock"));
                }),
                (t.getSelectedOptions = function (e, t) {
                    var i = [];
                    return (
                        e.forEach((e) => {
                            "dropdown" === t ? i.push(e.querySelector(".cc-select__btn").textContent.trim()) : i.push(e.querySelector("input:checked").value);
                        }),
                        i
                    );
                }),
                (t.updateVariantAvailability = function (e, i, o) {
                    var n = i[0].querySelectorAll(".option-selector"),
                        { selectorType: a } = n[0].dataset,
                        s = e;
                    s || (s = { options: t.getSelectedOptions(n, a) });
                    var r = (e, t, i) => {
                        var o = i ? theme.strings.buttonNoStock : theme.strings.buttonNoVariant;
                        if ((e.classList.toggle("is-unavailable", !t), "dropdown" === a)) {
                            var n = e.querySelector("em");
                            n && n.setAttribute("aria-hidden", t), t || (n ? (n.textContent = o) : (e.innerHTML = "".concat(e.innerHTML, " <em>").concat(o, "</em>")));
                        } else t ? e.nextElementSibling.removeAttribute("title") : (e.nextElementSibling.title = o);
                    };
                    i[0].querySelectorAll(".js-option").forEach((e) => {
                        r(e, !1, !1);
                    }),
                        n.forEach((e, t) => {
                            o.variants.forEach((i) => {
                                var o = 0;
                                if (
                                    (i.options.forEach((e, i) => {
                                        e === s.options[i] && i !== t && (o += 1);
                                    }),
                                    o === s.options.length - 1)
                                ) {
                                    var n = i.options[t],
                                        l = [...e.querySelectorAll(".js-option")].find((e) => ("dropdown" === a ? e.firstElementChild.textContent === n : e.nextElementSibling.textContent === n));
                                    l && r(l, i.available, !i.available);
                                }
                            });
                        });
                }),
                (t.updateProductDetails = function (i, o, n) {
                    var a = o.find(t.selectors.gallery),
                        s = o.find(".js-product-form"),
                        r = o.find(t.selectors.multiOption),
                        l = t.getProductData(o.data("product-id"));
                    t.updatePrice(i, o),
                        t.updateButtons(i, o),
                        t.updateBarcode(i, o),
                        t.updateSku(i, o),
                        t.updateInventoryNotice(i, o),
                        t.updateBackorder(i, o),
                        t.updateContainerStatusClasses(i, o),
                        r.length && r.data("show-availability") && t.updateVariantAvailability(i, o, l),
                        i && i.featured_media && a.trigger("variantImageSelected", i),
                        e(window).trigger("cc-variant-updated", { variant: i, product: l }),
                        s.data("enable-history-state") && !n && t.addVariantUrlToHistory(i);
                }),
                (t.initProductOptions = function (i) {
                    var o = e(i),
                        n = o.find(".js-product-form"),
                        a = o.find(t.selectors.multiOption),
                        s = o.find('select[name="id"]');
                    if (a.length) {
                        var r = t.getProductData(i.dataset.productId),
                            l = i.querySelectorAll(".option-selector"),
                            { selectorType: c } = l[0].dataset;
                        a.on("change.themeProductOptions firstrun.themeProductOptions", (e) => {
                            var n = t.getSelectedOptions(l, c),
                                a = r.variants.find((e) => e.options.every((e, t) => e === n[t]));
                            a ? s.val(a.id) : (a = !1),
                                "change" === e.type && "buttons" === c && e.target.nextElementSibling.hasAttribute("data-swatch") && (i.querySelector(".js-color-text").textContent = e.target.nextElementSibling.textContent),
                                t.updateProductDetails(a, o, "firstrun" === e.type);
                        }),
                            a.trigger("firstrun");
                    } else if (s.length) {
                        var d = t.getProductData(i.dataset.productId).variants.find((e) => e.id === Number(s.val()));
                        t.updateProductDetails(d, o, !0);
                    }
                    n && theme.applyAjaxToProductForm(n);
                }),
                (t.unloadProductOptions = function (i) {
                    var o = e(i),
                        n = o.find(".js-product-form"),
                        a = o.find(t.selectors.multiOption),
                        s = o.find('select[name="id"]');
                    a.length && a.off(".themeProductOptions"), n && (s.off(".themeProductOptions"), theme.removeAjaxFromProductForm(n));
                });
        })()),
        (theme.SlideshowSection = new (function () {
            (this.onSectionLoad = function (t) {
                e(".slideshow", t).each(function () {
                    var t = e(this).data("carousel"),
                        i = "fade" === e(this).data("transition");
                    e(this)
                        .on("init", function () {
                            e(".lazyload-manual", this).removeClass("lazyload-manual").addClass("lazyload"),
                                theme.settings.enable_overlay_transition &&
                                    e(".slick-active .transition", this)
                                        .removeClass("transition-out")
                                        .each(function () {
                                            e(this)
                                                .closest(".slideshow")
                                                .find(".slick-clone .block-" + e(this).closest(".slide").data("index") + " .transition")
                                                .removeClass("transition-out");
                                        });
                        })
                        .on("afterChange setPosition", function () {
                            theme.settings.enable_overlay_transition &&
                                (e(".slick-slide:not(.slick-active):not(.slick-clone) .transition", this)
                                    .addClass("transition-out")
                                    .each(function () {
                                        e(this)
                                            .closest(".slideshow")
                                            .find(".slick-clone:not(.slick-active) .block-" + e(this).closest(".slide").data("index") + " .transition")
                                            .addClass("transition-out");
                                    }),
                                e(".slick-active .transition", this)
                                    .removeClass("transition-out")
                                    .each(function () {
                                        e(this)
                                            .closest(".slideshow")
                                            .find(".block-" + e(this).closest(".slide").data("index") + " .transition")
                                            .removeClass("transition-out");
                                    }));
                        })
                        .slick({
                            autoplay: e(this).data("autoplay"),
                            fade: !t && i,
                            infinite: !0,
                            slidesToShow: t ? 2 : 1,
                            slidesToScroll: t ? 2 : 1,
                            speed: i ? 1e3 : 400,
                            cssEase: i ? "ease" : "cubic-bezier(0.86, 0, 0.07, 1)",
                            arrows: !0,
                            dots: !1,
                            prevArrow: [
                                '<button type="button" class="slick-prev" aria-label="',
                                theme.strings.previous,
                                '">',
                                '<span class="hide-until-sm">',
                                theme.icons.chevronLightLeft,
                                "</span>",
                                '<span class="show-until-sm">',
                                theme.icons.arrowLeft,
                                "</span>",
                                "</button>",
                            ].join(""),
                            nextArrow: [
                                '<button type="button" class="slick-next" aria-label="',
                                theme.strings.next,
                                '">',
                                '<span class="hide-until-sm">',
                                theme.icons.chevronLightRight,
                                "</span>",
                                '<span class="show-until-sm">',
                                theme.icons.arrowRight,
                                "</span>",
                                "</button>",
                            ].join(""),
                            autoplaySpeed: 1e3 * e(this).data("autoplay-speed"),
                            responsive: [
                                { breakpoint: 960, settings: { slidesToShow: 1, slidesToScroll: 1 } },
                                { breakpoint: 768, settings: { slidesToShow: 1, slidesToScroll: 1, cssEase: "cubic-bezier(0.77, 0, 0.175, 1)", arrows: !0, dots: !0 } },
                            ],
                        });
                });
            }),
                (this.onSectionUnload = function (t) {
                    e(".slick-slider", t).slick("unslick").off("init afterChange setPosition"), e(window).off(".slideshowSection");
                }),
                (this.onBlockSelect = function (t) {
                    e(t).closest(".slick-slider").slick("slickGoTo", e(t).data("slick-index")).slick("slickPause");
                }),
                (this.onBlockDeselect = function (t) {
                    e(t).closest(".slick-slider").slick("slickPlay");
                });
        })()),
        (theme.SlideshowWithTextSection = new (function () {
            (this.onSectionLoad = function (t) {
                e(".slideshow", t).each(function () {
                    e(this)
                        .on("init", function () {
                            e(".lazyload-manual", this).removeClass("lazyload-manual").addClass("lazyload");
                        })
                        .slick({
                            autoplay: e(this).data("autoplay"),
                            fade: "fade" === e(this).data("transition"),
                            autoplaySpeed: 1e3 * e(this).data("autoplay-speed"),
                            infinite: !0,
                            arrows: !0,
                            prevArrow: [
                                '<button type="button" class="slick-prev" aria-label="',
                                theme.strings.previous,
                                '">',
                                '<span class="hide-until-sm">',
                                theme.icons.chevronLightLeft,
                                "</span>",
                                '<span class="show-until-sm">',
                                theme.icons.arrowLeft,
                                "</span>",
                                "</button>",
                            ].join(""),
                            nextArrow: [
                                '<button type="button" class="slick-next" aria-label="',
                                theme.strings.next,
                                '">',
                                '<span class="hide-until-sm">',
                                theme.icons.chevronLightRight,
                                "</span>",
                                '<span class="show-until-sm">',
                                theme.icons.arrowRight,
                                "</span>",
                                "</button>",
                            ].join(""),
                            dots: !0,
                        });
                });
            }),
                (this.onSectionUnload = function (t) {
                    e(".slick-slider", t).slick("unslick").off("init");
                }),
                (this.onBlockSelect = function (t) {
                    e(t).closest(".slick-slider").slick("slickGoTo", e(t).data("slick-index")).slick("slickPause");
                }),
                (this.onBlockDeselect = function (t) {
                    e(t).closest(".slick-slider").slick("slickPlay");
                });
        })()),
        (theme.MainProductSection = new (function () {
            var t = [];
            (this.onSectionLoad = function (i) {
                e("[data-store-availability-container]", i).length && (this.storeAvailability = new theme.StoreAvailability(e("[data-store-availability-container]", i)[0])),
                    e(".media-gallery:not(.media-gallery--initialized)", i).each(function () {
                        t.push(new theme.ProductMediaGallery(e(this)));
                    }),
                    theme.OptionManager.initProductOptions(i);
                var o = e(".product-reviews-link", i),
                    n = document.getElementById("shopify-product-reviews");
                o.length && !n
                    ? o.attr("disabled", "")
                    : o.on("click", function (t) {
                          t.preventDefault(), e("html, body").animate({ scrollTop: e(e(this).attr("href")).offset().top - 120 }, 500, "swing");
                      });
            }),
                (this.onSectionUnload = function (i) {
                    if ((theme.OptionManager.unloadProductOptions(i), e(".size-chart-link", i).off("click"), t.length)) for (var o = 0; o < t.length; o++) t[o].destroy();
                    this.storeAvailability && this.storeAvailability.onSectionUnload();
                });
        })()),
        (theme.FeaturedProductSection = new (function () {
            var t = [];
            (this.onSectionLoad = function (i) {
                e(".media-gallery:not(.media-gallery--initialized)", i).each(function () {
                    t.push(new theme.ProductMediaGallery(e(this)));
                }),
                    theme.OptionManager.initProductOptions(i);
            }),
                (this.onSectionUnload = function (e) {
                    if ((theme.OptionManager.unloadProductOptions(e), t.length)) for (var i = 0; i < t.length; i++) t[i].destroy();
                });
        })()),
        (theme.TestimonialsSection = new (function () {
            var t = this;
            (this.assessTestimonialCarouselLayout = function (t) {
                e(".testimonials-nav__list.slick-slider", t).each(function () {
                    var t = e(this).width(),
                        i = 0;
                    e(this)
                        .find(".slick-slide")
                        .each(function () {
                            i += e(this).outerWidth(!0) + 1;
                        }),
                        e(this).toggleClass("slick-slider--center-carousel", i < t);
                });
            }),
                (this.onSectionLoad = function (i) {
                    var o = e(".testimonials-nav__list", i);
                    o
                        .on("afterChange", function (t, i) {
                            var o = e(this).closest(".testimonials");
                            clearTimeout(o.data("captionChangeTimeoutId")), clearTimeout(o.data("captionChangeTimeoutId2"));
                            var n = o.find(".testimonial")[o.find(".slick-current").data("slick-index")];
                            o.find(".testimonial--active").addClass("testimonial--fade-out"),
                                o.data(
                                    "captionChangeTimeoutId",
                                    setTimeout(function () {
                                        e(n).addClass("testimonial--active testimonial--fade-out").siblings(".testimonial--active").removeClass("testimonial--active"),
                                            o.data(
                                                "captionChangeTimeoutId2",
                                                setTimeout(function () {
                                                    e(n).removeClass("testimonial--fade-out");
                                                }, 10)
                                            );
                                    }, 400)
                                );
                        })
                        .slick({ autoplay: o.data("autoplay"), autoplaySpeed: o.data("autoplay-delay"), infinite: !1, slidesToShow: 1, centerMode: !0, variableWidth: !0, useTransform: !0, arrows: !1, dots: !1 }),
                        o.on("click keydown", ".testimonial-author", function (t) {
                            ("keydown" === t.type && 13 !== t.keyCode) || o.slick("slickGoTo", e(this).parent().data("slick-index"));
                        }),
                        e(window)
                            .off(".testimonialsSection")
                            .on("debouncedresize.testimonialsSection", function () {
                                t.assessTestimonialCarouselLayout(i), o.slick("setPosition");
                            }),
                        t.assessTestimonialCarouselLayout(i);
                }),
                (this.onSectionUnload = function (t) {
                    e(".slick-slider", t).slick("unslick").off("init afterChange click"), e(window).off(".testimonialsSection");
                }),
                (this.onBlockSelect = function (t) {
                    var i = e(t).closest(".slick-slider");
                    i.data("autoplay") && i.slick("slickGoTo", e(t).data("slick-index")).slick("slickPause");
                }),
                (this.onBlockDeselect = function (t) {
                    var i = e(t).closest(".slick-slider");
                    i.data("autoplay") && i.slick("slickPlay");
                });
        })()),
        (theme.BlogSection = new (function () {
            (this.onSectionLoad = function (t) {
                e("#filter-tag", t).on("change", function () {
                    window.location = e(this).val();
                }),
                    e(".blog-filter-toggle", t).on("click", function (t) {
                        t.preventDefault();
                        var i = e(this).outerHeight(!0) + 2;
                        e(this).closest(".blog-filter-reveal").addClass("blog-filter-reveal--fade-out");
                        var o = e(this).closest(".section-content").find(".blog-filter");
                        o.height(i),
                            setTimeout(function () {
                                o.addClass("filters--transition"),
                                    setTimeout(function () {
                                        o.css({ height: o.find(".blog-filter__inner").height() + "px", opacity: 1 });
                                    }, 10);
                            }, 250);
                    });
            }),
                (this.onSectionUnload = function (t) {
                    e("#filter-tag", t).off("change"), e(".blog-filter-toggle", t).off("click");
                });
        })()),
        (theme.announcementHeight = 0),
        (theme.HeaderSection = new (function () {
            (this.onSectionLoad = function (t) {
                if (theme.settings.enable_search) {
                    var i = e(".header-search__results-wrapper"),
                        o = e(".header-search__content", t),
                        n = e(".header-search__results", t),
                        a = null,
                        s = -1,
                        r = { search: /(\.[^\.]+)$/, replace: "_100x$1" },
                        l = function () {
                            var t = n.addClass("header-search__results--disband");
                            setTimeout(function () {
                                t.remove();
                            }, 500),
                                (n = e('<div class="header-search__results">').insertAfter(n));
                        };
                    e(".header-search .input-with-button__input", t).on("change.themeHeaderSection keyup.themeHeaderSection paste.themeHeaderSection", function (t) {
                        var c = e(this),
                            d = e(this).closest("form"),
                            h = i.data("live-search-meta");
                        if (c.val() != c.data("previous-value")) {
                            if ((o.toggleClass("header-search__content--input-entered", c.val().length > 0), o.addClass("header-search__content--loading"), clearTimeout(s), 0 == c.val().length))
                                return l(), void o.removeClass("header-search__content--has-results header-search__content--loading");
                            s = setTimeout(function () {
                                var t, s;
                                a && a.abort(),
                                    c.data("previous-value", c.val()),
                                    theme.Shopify.features.predictiveSearch
                                        ? ((t = theme.routes.search_url + "/suggest.json"),
                                          (s = {
                                              q: d.find('input[name="q"]').val(),
                                              resources: {
                                                  type: d.find('input[name="type"]').val(),
                                                  limit: 6,
                                                  options: { unavailable_products: "last", fields: h ? "title,product_type,variants.title,vendor,tag,variants.sku" : "title,product_type,variants.title,vendor" },
                                              },
                                          }))
                                        : ((t = d.attr("action") + (d.attr("action").indexOf("?") > -1 ? "&" : "?") + d.serialize() + "&view=data"), (s = null)),
                                    (a = e.ajax({
                                        url: t,
                                        data: s,
                                        dataType: "json",
                                        success: function (t) {
                                            var a = t.resources.results;
                                            l(), o.toggleClass("header-search__content--has-results", a.products.length > 0);
                                            for (var s = 0; s < a.products.length; s++) {
                                                var d = a.products[s],
                                                    h = e('<a class="search-result__link">').attr("href", d.url);
                                                d.image &&
                                                    e('<div class="search-result__image">')
                                                        .append(e("<img>").attr("src", d.image.replace(r.search, r.replace)).attr("alt", d.title))
                                                        .appendTo(h);
                                                var u = e('<div class="search-result__detail">').appendTo(h);
                                                i.data("live-search-vendor") && e('<div class="search-result__vendor">').html(d.vendor).appendTo(u), e('<div class="search-result__title">').html(d.title).appendTo(u);
                                                var p = e('<div class="search-result__price product-price">').appendTo(u);
                                                d.price_max != d.price_min && (e('<span class="product-price__from">').html(theme.strings.productsListingFrom).appendTo(p), p.append(" ")),
                                                    e('<span class="product-price__amount theme-money">').html(theme.Shopify.formatMoney(d.price_min, theme.money_format)).appendTo(p),
                                                    d.compare_at_price_min > d.price_min &&
                                                        (p.append(" "), e('<span class="product-price__compare theme-money">').html(theme.Shopify.formatMoney(d.compare_at_price_min, theme.money_format)).appendTo(p)),
                                                    e('<div class="search-result">').append(h).appendTo(n);
                                            }
                                            if ((a.pages && a.pages.length) || (a.articles && a.articles.length)) {
                                                var m = e('<div class="header-search__page-results">'),
                                                    f = function (t) {
                                                        for (var i = 0; i < t.length; i++) {
                                                            var o = t[i],
                                                                n = e('<a class="search-result__link">').attr("href", o.url).html(o.title);
                                                            e('<div class="search-result">').append(n).appendTo(m);
                                                        }
                                                    };
                                                e('<h3 class="header-search__small-heading meta">').html(theme.strings.searchResultsPages).appendTo(m), a.pages && f(a.pages), a.articles && f(a.articles), m.appendTo(n);
                                            }
                                            a.products.length > 0 &&
                                                e('<a class="feature-link">')
                                                    .attr("href", theme.routes.search_url + "?" + c.closest("form").serialize())
                                                    .html(theme.strings.searchSeeAll)
                                                    .appendTo(n);
                                            var v = n;
                                            setTimeout(function () {
                                                v.addClass("header-search__results--show");
                                            }, 10);
                                        },
                                        error: function (e) {
                                            console.log("Error", e);
                                        },
                                        complete: function (e) {
                                            (a = null), o.removeClass("header-search__content--loading");
                                        },
                                    }));
                            }, 400);
                        }
                    });
                }
                var c = document.querySelector(".announcement");
                if (
                    (c
                        ? ((theme.announcementHeight = c.clientHeight),
                          e(window).on("debouncedresize.headerSection", function () {
                              theme.announcementHeight = c.clientHeight;
                          }))
                        : (theme.announcementHeight = 0),
                    e("body").removeClass("scrolled-down"),
                    e(".pageheader__contents--sticky", t).length)
                ) {
                    var d = function () {
                        !e("body").hasClass("scrolled-down") &&
                            e(window).scrollTop() > theme.announcementHeight &&
                            (e("body").css("overflow-anchor", "none"),
                            clearTimeout(theme.debouncedWindowScrollOverflowAnchorTimeoutId),
                            (theme.debouncedWindowScrollOverflowAnchorTimeoutId = setTimeout(function () {
                                e("body").css("overflow-anchor", "");
                            }, 255))),
                            e("body").toggleClass("scrolled-down", e(window).scrollTop() > theme.announcementHeight);
                    };
                    e(window).on("scroll.headerSection", d), d();
                }
                e(".disclosure", t).each(function () {
                    e(this).data("disclosure", new theme.Disclosure(e(this)));
                });
                var h = e(".inline-header-nav > .nav-row"),
                    u = e(".inline-header-nav .tier-1 > ul");
                function p() {
                    theme.nav.bar.isInlineNavEnabled() && h.outerWidth() > u.outerWidth() ? theme.nav.bar.changeToInline() : theme.nav.bar.changeToBurger();
                }
                p(), e(window).on("debouncedresize.inlinenav", p);
            }),
                (this.onSectionUnload = function (t) {
                    theme.settings.enable_search && e(".header-search .input-with-button__input", t).off(".themeHeaderSection"),
                        e(".disclosure", t).each(function () {
                            e(this).data("disclosure").unload();
                        }),
                        e(window).off(".headerSection"),
                        e(window).off("debouncedresize.inlinenav");
                });
        })()),
        (theme.FooterSection = new (function () {
            (this.onSectionLoad = function (t) {
                e(".disclosure", t).each(function () {
                    e(this).data("disclosure", new theme.Disclosure(e(this)));
                });
            }),
                (this.onSectionUnload = function (t) {
                    e(".disclosure", t).each(function () {
                        e(this).data("disclosure").unload();
                    });
                });
        })()),
        (theme.CartSection = new (function () {
            (this.onSectionLoad = function (t) {
                e("#cartform input#terms", t).length > 0 &&
                    e(document).on("click.cartSection", '#cartform [name="checkout"]:submit, a[href="/checkout"]', function () {
                        if (0 == e("#cartform input#terms:checked").length) return alert(theme.strings.cartTermsConfirmation), !1;
                    }),
                    theme.cartNoteMonitor.load(e('.note-area [name="note"]', t));
            }),
                (this.onSectionUnload = function (t) {
                    e(document).off(".cartSection"), theme.cartNoteMonitor.unload(e('.note-area [name="note"]', t));
                });
        })()),
        (theme.toggleNav = function () {
            e("html").hasClass("open-menu")
                ? (e("#main-menu .lazyload-manual").removeClass("lazyload-manual").addClass("lazyload"), theme.checkMenuPadding(), e("body").css("padding-right", e.scrollBarWidth()))
                : e("body").css("padding-right", "");
        }),
        (theme.namespaceFromSection = function (t) {
            return [".", e(t).data("section-type"), e(t).data("section-id")].join("");
        }),
        e(function (e) {
            var t = window.matchMedia("(hover: hover)").matches && !window.matchMedia("(any-pointer: coarse)").matches,
                i = window.innerHeight,
                o = window.matchMedia("(orientation: portrait)").matches;
            if (
                ((theme.setViewportHeight = () => {
                    var e = document.getElementById("shopify-section-announcement"),
                        t = window.innerHeight;
                    e && (t -= e.offsetHeight), document.documentElement.style.setProperty("--viewport-height", "".concat(t, "px"));
                }),
                theme.setViewportHeight(),
                window.addEventListener(
                    "resize",
                    theme.debounce(() => {
                        if (window.innerHeight !== i) {
                            var e = window.matchMedia("(orientation: portrait)").matches;
                            (t || window.innerWidth > 1280 || e !== o) && theme.setViewportHeight(), (i = window.innerHeight), (o = e);
                        }
                    }, 250)
                ),
                !document.documentElement.classList.contains("template-password"))
            ) {
                (document.getElementById("main-menu-disclosure").open = !0),
                    (theme.setHeaderHeight = () => {
                        var e = document.getElementById("pageheader__contents");
                        document.documentElement.style.setProperty("--header-height", "".concat(e.offsetHeight, "px"));
                    }),
                    theme.setHeaderHeight(),
                    window.addEventListener("resize", theme.debounce(theme.setHeaderHeight, 250)),
                    e(document).on("keydown", ".main-menu-toggle:not(.main-menu-toggle--back)", function (t) {
                        (13 != t.which && 32 != t.which) ||
                            (t.preventDefault(),
                            t.stopPropagation(),
                            e("html").toggleClass("open-menu"),
                            theme.toggleNav(),
                            e("html").hasClass("open-menu") ? e("#main-menu .main-menu-links a:first").focus() : e("#pageheader .main-menu-toggle").focus());
                    }),
                    e(document).on("click", ".main-menu-toggle", function (t) {
                        t.preventDefault(), (e("html").hasClass("open-menu") && e(this).hasClass("main-menu-toggle--back")) || (e("html").toggleClass("open-menu"), theme.toggleNav());
                    }),
                    e(document).on("click", ".side-drawer__close-btn", function (e) {
                        document.documentElement.classList.remove("open-side-drawer"), e.target.closest(".side-drawer").classList.remove("is-open");
                    }),
                    e(document).on("click", ".bg-overlay", function () {
                        var e = document.documentElement.classList;
                        e.contains("open-menu") ? (e.remove("open-menu"), theme.toggleNav()) : (e.remove("open-side-drawer"), document.querySelector(".side-drawer.is-open").classList.remove("is-open"));
                    });
                e(document).on("click", ".has-children > .main-menu-link", function (t) {
                    t.preventDefault(), e(this).attr("aria-expanded", "true");
                    var i = e(this).closest(".main-menu-panel").addClass("main-menu-panel--inactive-left"),
                        o = e("#" + e(this).attr("aria-controls"));
                    i.attr("aria-hidden", "true"),
                        o.attr("aria-hidden", "false"),
                        e(".main-menu-toggle").addClass("main-menu-toggle--back"),
                        setTimeout(function () {
                            o.removeClass("main-menu-panel--inactive-right");
                        }, 300);
                }),
                    e(document).on("click", ".open-menu .main-menu-toggle.main-menu-toggle--back", function (t) {
                        return (
                            t.preventDefault(),
                            e(".main-menu-panel:not(.main-menu-panel--inactive-left):not(.main-menu-panel--inactive-right)").find(".main-menu-panel__back-link").trigger("click"),
                            setTimeout(function () {
                                e(".main-menu-panel--inactive-right").attr("aria-hidden", "true"), e(".main-menu-panel:not(.main-menu-panel--inactive-left):not(.main-menu-panel--inactive-right)").attr("aria-hidden", "false");
                            }, 300),
                            !1
                        );
                    }),
                    (theme.lastHoverInteractionTimestamp = -1),
                    e(document).on("click", ".multi-level-nav .nav-rows .contains-children > a", function () {
                        return e(this).parent().find("ul:first").slideToggle(300), !1;
                    }),
                    e(document).on("click forceopen forceclose", ".multi-level-nav .contains-mega-menu a.has-children", function (i) {
                        if (e(this).hasClass("column-title")) return !0;
                        t || i.preventDefault();
                        var o = 200,
                            n = Date.now();
                        if ("click" == i.type && n - theme.lastHoverInteractionTimestamp < 500) return !1;
                        ("forceopen" != i.type && "forceclose" != i.type) || (theme.lastHoverInteractionTimestamp = n);
                        var a = e(this).closest('[class^="tier-"]'),
                            s = a.parent(),
                            r = parseInt(a.attr("class").split("-")[1]) + 1,
                            l = "tier-" + r;
                        if (
                            ("forceopen" != i.type &&
                                s.children().each(function () {
                                    if (parseInt(e(this).attr("class").split("-")[1]) >= r)
                                        if ("forceclose" == i.type) {
                                            e(this).removeClass("tier-appeared");
                                            var t = e(this);
                                            theme.hoverRemoveTierTimeoutId = setTimeout(function () {
                                                t.remove();
                                            }, 260);
                                        } else e(this).slideUpAndRemove(o);
                                }),
                            e(this).hasClass("expanded") && "forceopen" != i.type)
                        )
                            e(this).removeClass("expanded").removeAttr("aria-expanded").removeAttr("aria-controls");
                        else {
                            a.find("a.expanded").removeClass("expanded").removeAttr("aria-expanded"), clearTimeout(theme.hoverRemoveTierTimeoutId);
                            var c = s.children("." + l);
                            0 == c.length
                                ? (c = e("<div />")
                                      .addClass(l)
                                      .attr("id", "menu-" + l)
                                      .appendTo(s)).css("height", "0px")
                                : c.css("height", c.height() + "px"),
                                c.empty().stop(!0, !1).append(e(this).siblings("ul").clone().attr("style", "")),
                                c.append(e(this).parent().find(".nav-contact-info").clone()),
                                c.animate({ height: c.children().outerHeight() }, o, function () {
                                    e(this).css("height", "");
                                }),
                                setTimeout(function () {
                                    c.addClass("tier-appeared");
                                }, 10),
                                e(this)
                                    .addClass("expanded")
                                    .attr("aria-expanded", "true")
                                    .attr("aria-controls", "menu-" + l),
                                e("body").addClass("nav-mega-open");
                        }
                    }),
                    (theme.closeOpenMenuItem = function () {
                        e("body").removeClass("nav-mega-open"), e(".multi-level-nav .has-children.expanded").trigger("forceclose");
                    }),
                    e(document).on("mouseenter mouseleave", ".multi-level-nav .tier-1 .contains-mega-menu", function (t) {
                        theme.viewport.isSm() &&
                            (clearTimeout(theme.closeOpenMenuItemTimeoutId),
                            "mouseenter" == t.type
                                ? (e(".lazyload-manual", this).removeClass("lazyload-manual").addClass("lazyload"), e(this).children("a").trigger("forceopen"))
                                : (theme.closeOpenMenuItemTimeoutId = setTimeout(theme.closeOpenMenuItem, 200)));
                    }),
                    e(document).on("mouseenter", ".multi-level-nav .contains-children", function () {
                        e(".lazyload-manual", this).removeClass("lazyload-manual").addClass("lazyload");
                    }),
                    e(document).on("mouseleave", ".multi-level-nav .tier-appeared", function () {
                        theme.viewport.isSm() && (clearTimeout(theme.closeOpenMenuItemTimeoutId), (theme.closeOpenMenuItemTimeoutId = setTimeout(theme.closeOpenMenuItem, 50)));
                    }),
                    e(document).on("mouseenter", ".multi-level-nav .tier-2, .multi-level-nav .tier-3", function () {
                        theme.viewport.isSm() && clearTimeout(theme.closeOpenMenuItemTimeoutId);
                    }),
                    (e.fn.slideUpAndRemove = function () {
                        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 200;
                        e(this).each(function () {
                            e(this).slideUp(t, function () {
                                e(this).remove();
                            });
                        });
                    }),
                    e(document).on("click", ".main-menu-panel__back-link", function (t) {
                        t.preventDefault();
                        var i = e(e(this).attr("href"));
                        e(this).closest(".main-menu-panel").addClass("main-menu-panel--inactive-right");
                        "#main-menu-panel" == e(this).attr("href") &&
                            (e(".main-menu-panel--child.main-menu-panel--inactive-left").addClass("main-menu-panel--inactive-right").removeClass("main-menu-panel--inactive-left"),
                            e("#pageheader .main-menu-toggle").removeClass("main-menu-toggle--back")),
                            setTimeout(function () {
                                i.removeClass("main-menu-panel--inactive-left");
                            }, 300);
                    }),
                    document.querySelectorAll(".input-with-clear__clear").forEach((e) => {
                        e.addEventListener("click", () => {
                            var t = e.previousElementSibling;
                            (t.value = ""), t.dispatchEvent(new Event("change"));
                        });
                    }),
                    e(document).on("variantImageSelected", ".media-gallery", function (t, i) {
                        var o = i.featured_media.preview_image.src.split("?")[0].replace(/http[s]?:/, ""),
                            n = e(this).find('.thumb[href^="' + o + '"]:first');
                        n.trigger("click");
                        var a = e(this).find(".thumbnails__scroller");
                        a.length && (window.innerWidth >= 992 ? a.animate({ scrollTop: a.scrollTop() + (n.offset().top - a.offset().top) }, 500) : a.animate({ scrollLeft: a.scrollLeft() + (n.offset().left - a.offset().left) }, 500));
                    }),
                    e(document).on("click", ".js-prod-qty", function () {
                        var t = e(this).closest(".qty-selector").find("input.quantity"),
                            i = parseInt(t.val()),
                            o = "+" === e(this).data("direction") ? (i += 1) : (i -= 1);
                        t.val(Math.max(1, o));
                    }),
                    window.location.href.indexOf("/challenge") > 0 && -1 === window.location.href.indexOf("/pages") && (document.getElementById("pagefooter").style.display = "none"),
                    e(document).on("shopify:section:load", function (e) {
                        theme.checkForBannerBehindHeader(),
                            (document.getElementById("main-menu-disclosure").open = !0),
                            "shopify-section-header" === e.target.id
                                ? setTimeout(() => {
                                      theme.setHeaderHeight(), theme.checkMenuPadding();
                                  }, 10)
                                : "shopify-section-announcement" === e.target.id && theme.setViewportHeight();
                    }),
                    e(document).on("shopify:section:unload", function () {
                        setTimeout(() => {
                            theme.checkForBannerBehindHeader(), e("html").hasClass("open-menu") && e("#main-menu .lazyload-manual").removeClass("lazyload-manual").addClass("lazyload");
                        }, 10);
                    }),
                    e(document).on("shopify:section:reorder", function () {
                        theme.checkForBannerBehindHeader();
                    });
            }
            e("a[rel=lightbox]").colorbox({ maxWidth: "94%" }),
                e(window).height() >= theme.lightbox_min_window_height && e(window).width() >= theme.lightbox_min_window_width && e('a[rel="gallery"]').colorbox({ rel: "gallery", maxWidth: "94%" }),
                e(document).on("click", ".size-chart-link", function () {
                    return e.colorbox({ html: e(".size-chart-content").html(), maxWidth: "94%" }), !1;
                }),
                e(".newsletter-response").length > 0 &&
                    0 === e(".cc-popup-form__response--success").length &&
                    e.colorbox({ fixed: !0, maxWidth: "94%", html: ['<div class="signup-modal-feedback">', e(".newsletter-response:first").html(), "</div>"].join("") }),
                window.addEventListener("keydown", function t(i) {
                    9 === i.keyCode && (e("body").addClass("user-is-tabbing"), window.removeEventListener("keydown", t));
                }),
                e(document)
                    .on("cc:video:play", function () {
                        e(window).outerWidth() < 768 && e("body").addClass("video-modal-open");
                    })
                    .on("cc:video:stop", function () {
                        e(window).outerWidth() < 768 && e("body").removeClass("video-modal-open");
                    });
        }),
        e(function () {
            theme.Sections.init(),
                document.documentElement.classList.contains("template-password") ||
                    (theme.Sections.register("header", theme.HeaderSection, { deferredLoad: !1 }),
                    theme.Sections.register("footer", theme.FooterSection),
                    theme.Sections.register("collection", theme.ProductResultsSection, { deferredLoad: !1 }),
                    theme.Sections.register("product", theme.MainProductSection, { deferredLoad: !1 }),
                    theme.Sections.register("featured-product", theme.FeaturedProductSection),
                    theme.Sections.register("cart", theme.CartSection, { deferredLoad: !1 }),
                    theme.Sections.register("search", theme.ProductResultsSection, { deferredLoad: !1 })),
                theme.Sections.register("slideshow", theme.SlideshowSection),
                theme.Sections.register("slideshow-with-text", theme.SlideshowWithTextSection),
                theme.Sections.register("blog", theme.BlogSection, { deferredLoad: !1 }),
                theme.Sections.register('recently-viewed', theme.RecentlyViewed);
                theme.Sections.register("testimonials", theme.TestimonialsSection),
                theme.Sections.register("background-video", theme.VideoManager);
        }),
        e.extend(e.colorbox.settings, {
            previous: '<svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><title>Previous</title><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg>',
            next: '<svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><title>Next</title><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/></svg>',
            close:
                '<svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><title>Close</title><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>',
        }),
        e(function (e) {
            r.sections.length
                ? r.sections.forEach((e) => {
                      try {
                          var t = {};
                          void 0 !== e.deferredLoad && (t.deferredLoad = e.deferredLoad),
                              void 0 !== e.deferredLoadViewportExcess && (t.deferredLoadViewportExcess = e.deferredLoadViewportExcess),
                              theme.Sections.register(e.name, e.section, t);
                      } catch (t) {
                          console.error("Unable to register section ".concat(e.name, "."), t);
                      }
                  })
                : console.warn("Barry: No common sections have been registered.");
        });
})(theme.jQuery);
